// import { useEffect, useState } from "react";
// import {
//   getLifeStages,
//   getVisibleQuestions,
//   formatStageLabel,
//   getEntryReasons,
//   getLifeStageDetail,
//   getLifeStageMeta,
// } from "../components/Reusablesteps/Resolvelifestage";
// import { useNavigate } from "react-router-dom";
// import StartCareJourneyScreen from "../components/CareJourney/Startcarejourney";
// import NewPatientScreen from "../components/CareJourney/Newpatientscreen";
// import ProfileScreen from "../components/CareJourney/Profilescreen";
// import DigitalHealthFAB from "../components/Digitalhealth";
// import CareRecommendationScreen from "../components/CareJourney/CareRecommendationScreen";
// import HeightWeightScreen from "../components/CareJourney/Heightweightscreen";
// import BasicLifeStageScreen from "../components/CareJourney/Basiclifestagescreen";
// import StepperProgress from "../components/Reusablesteps/Stepperprogress";
// import styles from '../styles/pagestyles.module.css';
// import { BtnAskNavigator, BtnBack, BtnContinue } from "../components/Reusablecomponents/Button/Reusableutton";
// import useScrollToBottom from "../hooks/useScrollToBottom";
// import { ScrollToBottomButton } from "../components/common/ScrollToBottomButton";
// import ConsentScreen from "../components/Reusablecomponents/Consentscreen/Consentscreen";

// // ─────────────────────────────────────────────────────────────────────────────
// // DESIGN TOKENS
// // ─────────────────────────────────────────────────────────────────────────────
// const T = {
//   purple700: "var(--primary-color)",
//   purpleBtn: "var(--primary-color)",
//   purpleLight: "var(--ava-bg-primary-light)",
//   purpleBorder: "var(--primary-color)",
//   purpleTag: "var(--ava-bg-primary-light)",
//   dark: "#0F0A1E",
//   heading: "#1A1033",
//   body: "#374151",
//   sub: "#6B7280",
//   muted: "#9CA3AF",
//   border: "#E5E7EB",
//   borderFocus: "var(--primary-color)",
//   pageBg: "#FFFFFF",
//   lavenderBg: "var(--ava-bg-primary-light)",
//   cardBg: "#FFFFFF",
//   inputBg: "#FFFFFF",
//   trustBg: "var(--ava-bg-primary-light)",
//   infoBg: "#EFF6FF",
//   infoBorder: "#BFDBFE",
//   infoText: "#1E40AF",
//   green: "#10B981",
//   amber: "#F59E0B",
//   red: "#EF4444",
//   pink: "#EC4899",
//   pinkLight: "#FFF0F5",
//   pinkBorder: "#FBCFE8",
// };

// // ─── getStageKey ───────────────────────────────────────────────────────────
// export function getStageKey(stage) {
//   if (!stage) return "youngAdult";
//   const s = stage.toString().toLowerCase().replace(/\s+/g, "");
//   if (s.includes("adolesc")) return "adolescence";
//   if (s.includes("young")) return "youngAdult";
//   if (s.includes("mature")) return "matureReproductive";
//   if (s.includes("peri")) return "perimenopause";
//   if (s.includes("postmeno")) return "postmenopause";
//   if (s.includes("meno")) return "menopause";
//   if (s.includes("geriatric")) return "geriatric";
//   return stage;
// }

// const CONSENT_CONFIG = {
//   "pageTitle": "Consent & Privacy",
//   "pageSubtitle": "Before we personalize your care journey, please review how your information will be used.",
//   "illustrationEmoji": "🛡️",
//   "requiredItems": [
//     { "id": "carePersonalization", "icon": "🤝", "title": "Care Journey Personalization", "description": "Use my answers to personalize my women's health care journey.", "type": "checkbox", "required": true },
//     { "id": "clinicAccess", "icon": "👥", "title": "Clinic Care Team Access", "description": "Allow the selected clinic's authorized care team to view my submitted information.", "type": "checkbox", "required": true },
//     { "id": "privacyNotice", "icon": "📋", "title": "Privacy Notice Acknowledgement", "description": "I have read and understand the privacy notice.", "type": "checkbox", "required": true }
//   ],

//   "sideCard": {
//     "title": "Your privacy is our priority",
//     "description": "We collect only what's necessary to provide safe, effective, and personalized care for you.",
//     "items": [
//       { "icon": "🛡️", "title": "Secure & Encrypted", "desc": "Your data is encrypted and stored securely." },
//       { "icon": "🔒", "title": "Private by Design", "desc": "We limit access to your data to authorized care team members only." },
//       { "icon": "👤", "title": "You're in Control", "desc": "You can manage or withdraw optional consent anytime." }
//     ],
//     "infoBubble": "You can manage optional consent later from your profile.",
//     "ctaLabel": "Continue Securely"
//   }
// };
// // ─── ENTRY_REASONS_STATIC ──────────────────────────────────────────────────
// export const ENTRY_REASONS_STATIC = {
//   menstrual_health: { label: "Menstrual Health", emoji: "🗓️", desc: "Cycle irregularities, cramps, heavy or missed periods." },
//   pcos_screening: { label: "PCOS Screening", emoji: "🔬", desc: "Hormonal symptoms, acne, hair growth, weight changes." },
//   pelvic_pain: { label: "Pelvic Pain", emoji: "💜", desc: "Lower abdominal, back, or pelvic floor pain." },
//   menopause_symptoms: { label: "Menopause Symptoms", emoji: "🌡️", desc: "Hot flushes, night sweats, mood and sleep changes." },
//   infection_gynae: { label: "Infection / Discharge", emoji: "🔬", desc: "Unusual discharge, itching, burning, or odour." },
//   early_pregnancy: { label: "Early Pregnancy", emoji: "🤰", desc: "Missed period, nausea, breast tenderness, fatigue." },
//   preconception: { label: "Preconception Care", emoji: "🌿", desc: "Cycle tracking, supplements, health checks before TTC." },
//   fertility: { label: "Fertility", emoji: "🌿", desc: "Challenges conceiving, ovulation, or cycle concerns." },
//   heavy_bleeding: { label: "Heavy Bleeding", emoji: "🩸", desc: "Soaking pads, clots, prolonged or irregular bleeding." },
//   urogenital: { label: "Urogenital Health", emoji: "💧", desc: "Dryness, urgency, leakage, or pelvic floor concerns." },
//   bone_health: { label: "Bone & Heart Health", emoji: "🦴", desc: "Joint pain, fracture risk, blood pressure, cholesterol." },
//   mental_wellbeing: { label: "Mood & Mental Wellbeing", emoji: "🧠", desc: "Low mood, anxiety, sleep problems, or burnout." },
//   contraception: { label: "Contraception", emoji: "💊", desc: "Choosing, changing, or managing contraception." },
//   puberty_education: { label: "Puberty & Education", emoji: "📚", desc: "First period, cycle questions, body changes guidance." },
//   lifestyle: { label: "Lifestyle & Wellness", emoji: "🥗", desc: "Weight, energy, sleep, stress, nutrition, fitness." },
//   preventive_care: { label: "Preventive Care", emoji: "✅", desc: "Screenings, vaccinations, wellness checks." },
//   chronic_disease: { label: "Chronic Condition Care", emoji: "🩺", desc: "Diabetes, thyroid, BP, ongoing medication management." },
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // HELPER — resolve life stage info from profile (used across all screens)
// // ─────────────────────────────────────────────────────────────────────────────
// /**
//  * resolveLifeStageFromProfile(profile, lifeStageAnswers)
//  * Single source of truth for stage resolution used by every screen.
//  * Priority: lifeStageAnswers.stages → getLifeStages(profile.age, profile.marital)
//  */
// function resolveLifeStageFromProfile(profile = {}, lifeStageAnswers = {}) {
//   const stages =
//     lifeStageAnswers?.stages?.length > 0
//       ? lifeStageAnswers.stages
//       : getLifeStages(profile?.age, profile?.marital);

//   const primaryStage = stages[0] || "youngAdult";
//   const stageDetail = getLifeStageDetail(primaryStage) || {};
//   const stageMeta = getLifeStageMeta(primaryStage) || { emoji: "🌸", color: "var(--ava-bg-primary-light)" };
//   const stageName = stageDetail.name || formatStageLabel(primaryStage);
//   const journey = getEntryReasons(stages);
//   const journeyTitle = journey?.journeyTitle || "Women's Health Journey";
//   const journeyEmoji = stageMeta.emoji || "🌸";

//   return {
//     stages,
//     primaryStage,
//     stageDetail,
//     stageMeta,
//     stageName,
//     journey,
//     journeyTitle,
//     journeyEmoji,
//   };
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // REUSABLE PRIMITIVE COMPONENTS
// // ─────────────────────────────────────────────────────────────────────────────
// export const IconCircle = ({ children, size = 36, bg = T.purpleLight }) => (
//   <div style={{
//     width: size, height: size, borderRadius: "50%", background: bg,
//     display: "flex", alignItems: "center", justifyContent: "center",
//     flexShrink: 0, fontSize: size * 0.42,
//   }}>
//     {children}
//   </div>
// );

// export const StageBadge = ({ label, emoji }) => (
//   <span style={{
//     display: "inline-flex", alignItems: "center", gap: 6,
//     background: T.purpleTag, borderRadius: 20, padding: "4px 12px",
//     fontSize: 11, fontWeight: 600, color: T.purple700,
//   }}>
//     {emoji || "🌸"} {label}
//   </span>
// );

// export const SectionLabel = ({ children }) => (
//   <p style={{ fontSize: 10, fontWeight: 700, color: T.muted, letterSpacing: "0.08em", textTransform: "uppercase", padding: "10px 0 4px", margin: 0 }}>
//     {children}
//   </p>
// );

// export const Chip = ({ label, selected, onClick }) => (
//   <button onClick={onClick} style={{
//     padding: "7px 14px", borderRadius: 8, fontSize: 11, fontWeight: selected ? 600 : 400,
//     border: selected ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//     background: selected ? T.purpleLight : "#fff",
//     color: selected ? T.purple700 : T.sub,
//     cursor: "pointer", transition: "all 0.15s",
//   }}>
//     {label}
//   </button>
// );

// export const SymptomChip = ({ label, selected, onClick }) => {
//   const icon = SYMPTOM_ICONS[label] || "•";
//   return (
//     <button onClick={onClick} style={{
//       display: "flex", alignItems: "center", gap: 8, padding: "10px 14px",
//       borderRadius: 12, textAlign: "left", position: "relative",
//       border: selected ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//       // background: selected ? T.purpleLight : "#fff",
//       color: selected ? T.purple700 : T.body,
//       cursor: "pointer", fontSize: 12, fontWeight: selected ? 600 : 400,
//       transition: "all 0.18s",
//     }}>
//       <IconCircle size={32} bg={selected ? "var(--ava-bg-primary-light)" : "#F3F4F6"}>{icon}</IconCircle>
//       <span style={{ flex: 1 }}>{label}</span>
//       {selected && (
//         <div style={{ width: 20, height: 20, borderRadius: "50%", background: T.purple700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//           <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
//             <path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//           </svg>
//         </div>
//       )}
//     </button>
//   );
// };

// export const CareCheckbox = ({ checked, onChange }) => (
//   <div onClick={onChange} style={{
//     width: 20, height: 20, borderRadius: 5, flexShrink: 0, cursor: "pointer",
//     border: checked ? "none" : `2px solid ${T.border}`,
//     background: checked ? T.purple700 : "#fff",
//     display: "flex", alignItems: "center", justifyContent: "center",
//   }}>
//     {checked && <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}
//   </div>
// );

// export const Toggle = ({ on, onChange }) => (
//   <div onClick={onChange} style={{
//     width: 40, height: 22, borderRadius: 11, cursor: "pointer",
//     background: on ? T.purple700 : T.border, position: "relative", transition: "background 0.2s",
//   }}>
//     <div style={{
//       width: 16, height: 16, borderRadius: "50%", background: "#fff",
//       position: "absolute", top: 3, left: on ? 21 : 3, transition: "left 0.2s",
//     }} />
//   </div>
// );

// export const InfoBox = ({ children }) => (
//   <div style={{ background: T.infoBg, border: `1px solid ${T.infoBorder}`, borderRadius: 8, padding: "8px 10px" }}>
//     <p style={{ fontSize: 10, color: T.infoText, margin: 0, lineHeight: 1.5 }}>ℹ️ {children}</p>
//   </div>
// );

// export const PurpleInfoBox = ({ icon, title, desc }) => (
//   <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", gap: 8 }}>
//     <span style={{ fontSize: 14 }}>{icon}</span>
//     <div>
//       <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, margin: "0 0 2px" }}>{title}</p>
//       <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{desc}</p>
//     </div>
//   </div>
// );

// export const TrustBar = () => (
//   <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 12, padding: "8px 0 2px" }}>
//     {["🔒 Secure", "👩‍⚕️ Expert-led", "🌸 Personalised"].map(item => (
//       <span key={item} style={{ fontSize: 10, color: T.muted, fontWeight: 500 }}>{item}</span>
//     ))}
//   </div>
// );

// export const FeatureItem = ({ icon, title, desc }) => (
//   <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
//     <div style={{ width: 28, height: 28, borderRadius: 8, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>{icon}</div>
//     <div>
//       <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: "0 0 2px" }}>{title}</p>
//       <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{desc}</p>
//     </div>
//   </div>
// );

// export const StyledSelect = ({ value, onChange, options, placeholder }) => (
//   <div style={{ position: "relative" }}>
//     <select value={value} onChange={e => onChange(e.target.value)} style={{
//       width: "100%", padding: "10px 36px 10px 12px", borderRadius: 8, appearance: "none",
//       border: `1.5px solid ${value ? T.purpleBorder : T.border}`,
//       fontSize: 12, color: value ? T.heading : T.muted,
//       background: "#fff", cursor: "pointer", outline: "none",
//     }}>
//       <option value="">{placeholder}</option>
//       {options.map(o => <option key={o} value={o}>{o}</option>)}
//     </select>
//     <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: T.muted, fontSize: 12 }}>▾</span>
//   </div>
// );

// export const YesNoBtn = ({ label, active, onClick }) => (
//   <button onClick={onClick} style={{
//     padding: "6px 16px", borderRadius: 8, fontSize: 11, fontWeight: active ? 700 : 400,
//     border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//     background: active ? T.purpleLight : "#fff",
//     color: active ? T.purple700 : T.sub, cursor: "pointer", transition: "all 0.15s",
//   }}>
//     {label}
//   </button>
// );

// export const YesNo = ({ value, onChange }) => (
//   <div style={{ display: "flex", gap: 8 }}>
//     {["Yes", "No"].map(opt => (
//       <button key={opt} onClick={() => onChange(opt)} style={{
//         flex: 1, padding: "10px 0", borderRadius: 8, fontSize: 12,
//         border: value === opt ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//         background: value === opt ? T.purpleLight : "#fff",
//         color: value === opt ? T.purple700 : T.sub,
//         fontWeight: value === opt ? 700 : 400, cursor: "pointer", transition: "all 0.15s",
//       }}>
//         {opt}
//       </button>
//     ))}
//   </div>
// );

// // export const BtnBack = ({ onClick }) => (
// //   <button onClick={onClick} style={{
// //     display: "flex", alignItems: "center", gap: 5, padding: "7px 14px",
// //     borderRadius: 8, fontSize: 12, fontWeight: 600,
// //     border: `1.5px solid ${T.border}`, background: "#fff", color: T.body, cursor: "pointer",
// //   }}>
// //     ← Back
// //   </button>
// // );

// // export const BtnContinue = ({ onClick, disabled = false, label = "Continue →", wide = false, color = T.purpleBtn }) => (
// //   <button onClick={onClick} disabled={disabled} style={{
// //     display: "flex", alignItems: "center", gap: 8,
// //     paddingLeft: 18, paddingRight: 18, paddingTop: 8, paddingBottom: 8,
// //     borderRadius: 8, fontSize: 12, fontWeight: 600, color: "#fff", border: "none",
// //     background: disabled ? "var(--ava-color-disabled, #BDBDBD)" : color,
// //     cursor: disabled ? "not-allowed" : "pointer",
// //     minWidth: wide ? undefined : 140, width: wide ? "100%" : undefined,
// //     justifyContent: "center", opacity: disabled ? 0.75 : 1, transition: "background 0.15s",
// //   }}>
// //     {label}
// //   </button>
// // );

// // export const BtnAskNavigator = ({ onClick }) => (
// //   <button onClick={onClick} style={{
// //     display: "flex", alignItems: "center", gap: 6, padding: "6px 14px",
// //     borderRadius: 20, fontSize: 11, fontWeight: 600,
// //     border: `1.5px solid ${T.purpleBorder}`, background: T.purpleLight,
// //     color: T.purple700, cursor: "pointer",
// //   }}>
// //     💬 Ask a Care Navigator
// //   </button>
// // );

// export const FooterNote = ({ children }) => (
//   <p style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, color: T.muted, margin: 0, whiteSpace: "nowrap" }}>
//     🔒 {children}
//   </p>
// );

// export const FooterBar = ({ left, center, right }) => (
//   <div style={{
//     display: "flex", alignItems: "center", justifyContent: "space-between",
//     padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
//   }}>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
//   </div>
// );

// export const PageWrap = ({ children }) => (
//   <div style={{
//     minHeight: "100vh",
//     background: "linear-gradient(135deg,#e8f4f8 0%,#f0eeff 50%,#e8f4f8 100%)",
//     display: "flex", alignItems: "flex-start", justifyContent: "center",
//     padding: "48px 16px 24px", fontFamily: "system-ui, -apple-system, sans-serif",
//     boxSizing: "border-box",
//   }}>
//     <div style={{
//       width: "100%", maxWidth: 960, background: "white", borderRadius: 20,
//       padding: "24px 32px 20px", boxShadow: "0 4px 40px rgba(61,26,138,0.09)",
//       border: `1px solid ${T.border}`, boxSizing: "border-box",
//     }}>
//       {children}
//     </div>
//   </div>
// );

// export const RightCard = ({ children, style = {} }) => (
//   <div style={{
//     background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
//     display: "flex", flexDirection: "column", gap: 10, ...style,
//   }}>
//     {children}
//   </div>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // SYMPTOM ICONS MAP
// // ─────────────────────────────────────────────────────────────────────────────
// const SYMPTOM_ICONS = {
//   "Irregular periods": "🗓️", "Acne": "🫧", "Facial hair growth": "✨",
//   "Weight gain": "⚖️", "Hair thinning": "💆", "Pelvic pain": "💜",
//   "Bloating": "🫁", "Breast tenderness": "🌸", "Mood swings": "🧠",
//   "Headaches/migraines": "🤕", "Nausea": "🤢", "Fatigue": "😴",
//   "None of the above": "✅", "Lower abdomen": "📍", "Lower back": "🔙",
//   "Pelvic floor / between the hip bones": "💜", "During sex (deep pain)": "❤️",
//   "During urination": "💧", "During bowel movements": "⚠️",
//   "Hot flushes": "🌡️", "Night sweats": "💧", "Sleep disturbances": "🌙",
//   "Reduced sex drive": "❤️", "Vaginal dryness": "💧",
//   "Joint pain or stiffness": "🦴",
//   "Unusual discharge (colour, smell, or texture)": "🔬",
//   "Itching or burning": "🔥", "Pain during sex": "❤️",
//   "Pain or burning when urinating": "💧", "Fever or chills": "🌡️",
//   "Pelvic pain or pressure": "💜",
// };
// const getSymptomIcon = (label) => SYMPTOM_ICONS[label] || "•";

// // ─────────────────────────────────────────────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────────────────────────────────────────────
// const JOURNEY_OPTIONS = [
//   { value: "pcos", label: "PCOS / Irregular Period Journey", emoji: "🔬", desc: "For irregular cycles, hormonal symptoms, acne, weight changes, or cycle concerns" },
//   { value: "pregnancy", label: "Pregnancy Start Journey", emoji: "🤰", desc: "For pregnancy confirmation, prenatal care, symptoms, scans, and routine check-ups" },
//   { value: "fertility", label: "Fertility / Preconception Journey", emoji: "🌿", desc: "For trying to conceive, fertility planning, cycle tracking, and preconception support" },
//   { value: "postpartum", label: "Postpartum Journey", emoji: "👶", desc: "For recovery after delivery, breastfeeding, mood, bleeding, and follow-up care" },
//   { value: "menopause", label: "Perimenopause / Menopause Journey", emoji: "🌡️", desc: "For hot flashes, cycle changes, sleep, mood, and menopause wellness" },
//   { value: "general", label: "General Women's Health", emoji: "❤️", desc: "For preventive check-ups, pelvic pain, infection symptoms, and overall wellness" },
// ];

// const SYMPTOM_MAP = {
//   menstrual_health: ["Irregular periods", "Painful cramps", "Heavy bleeding", "Spotting between periods", "Missed period", "Blood clots", "Bloating", "Mood swings", "Fatigue", "PMS symptoms"],
//   pcos_screening: ["Irregular periods", "Acne", "Facial hair growth", "Weight gain", "Hair thinning", "Pelvic pain", "Bloating", "Mood swings", "Fatigue", "Strong sugar cravings"],
//   pelvic_pain: ["Lower abdomen", "Lower back", "Pelvic floor / between the hip bones", "During sex (deep pain)", "During urination", "During bowel movements", "Bloating", "Nausea", "Fatigue", "Pelvic pressure"],
//   menopause_symptoms: ["Hot flushes", "Night sweats", "Sleep disturbances", "Mood swings", "Reduced sex drive", "Vaginal dryness", "Joint pain or stiffness", "Fatigue", "Weight gain", "Brain fog"],
//   infection_gynae: ["Unusual discharge (colour, smell, or texture)", "Itching or burning", "Pain during sex", "Pain or burning when urinating", "Fever or chills", "Pelvic pain or pressure", "Nausea", "Fatigue", "Unpleasant odour"],
//   early_pregnancy: ["Missed period", "Nausea or vomiting", "Breast tenderness", "Fatigue", "Frequent urination", "Light spotting / implantation bleeding", "Mild cramping", "Mood changes", "Food aversions or cravings"],
//   preconception: ["Irregular cycles", "Ovulation tracking concerns", "Acne or excess hair growth", "Weight gain or difficulty losing weight", "Thyroid or hormonal concerns", "Previous miscarriage", "Stress or anxiety", "Low energy", "Partner fertility concerns"],
//   fertility: ["Not conceiving after trying", "Irregular or absent ovulation", "PCOS symptoms", "Endometriosis pain", "Fibroids", "Previous miscarriage", "Cycle length concerns", "Age-related fertility concerns", "Low libido"],
//   heavy_bleeding: ["Soaking a pad or tampon every hour", "Clots larger than 2 cm", "Bleeding lasting more than 7 days", "Irregular or unpredictable bleeding", "Postmenopausal bleeding", "Pelvic pain", "Dizziness or lightheadedness", "Fatigue or anaemia symptoms"],
//   urogenital: ["Vaginal dryness", "Pain during sex", "Urinary urgency", "Urine leakage", "Feeling of prolapse / pelvic pressure", "Recurrent UTIs", "Itching or burning", "Frequent night-time urination"],
//   bone_health: ["Joint pain or stiffness", "Back or spine pain", "Height loss over time", "Previous fracture from minor fall", "Chest pain or tightness", "Shortness of breath", "High blood pressure history", "Fatigue"],
//   mental_wellbeing: ["Persistent low mood", "Anxiety or worry", "Sleep problems", "Mood swings or irritability", "Difficulty concentrating", "Loss of interest in activities", "Appetite changes", "Fatigue", "Panic attacks", "Feeling overwhelmed"],
//   contraception: ["Irregular bleeding on current contraception", "Mood changes since starting contraception", "Weight changes", "Headaches or migraines", "Decreased sex drive", "Nausea", "Need for emergency contraception", "Skin changes or acne"],
//   puberty_education: ["First period concerns", "Irregular early cycles", "Breast development concerns", "Body hair growth", "Acne", "Mood swings", "Body image concerns", "Hygiene or period product questions"],
//   lifestyle: ["Unexplained weight gain", "Persistent fatigue or low energy", "Poor or disrupted sleep", "High stress or burnout", "Nutritional concerns", "Exercise intolerance", "Digestive or gut issues", "Skin or hair concerns"],
//   preventive_care: ["Due for Pap smear / cervical screening", "Breast self-exam concerns", "Vaccination needs", "Blood pressure concerns", "Weight management", "Family history of cancer or heart disease", "General wellness review", "Bone density check"],
//   chronic_disease: ["Blood sugar issues or diabetes risk", "High blood pressure", "Thyroid concerns", "Cholesterol or heart disease risk", "Joint pain from arthritis", "Kidney or urinary issues", "Ongoing fatigue", "Medication management concerns"],
// };

// const SAFETY_SYMPTOMS = [
//   { label: "None of these", icon: "✅" },
//   { label: "Shortness of breath", icon: "🫁" },
//   { label: "Severe pain", icon: "⚡" },
//   { label: "Heavy bleeding", icon: "🩸" },
//   { label: "Dizziness or fainting", icon: "😵" },
//   { label: "Fever", icon: "🌡️" },
//   { label: "Reduced baby movement", icon: "🍼" },
//   { label: "Severe headache", icon: "🤕" },
// ];

// // ─────────────────────────────────────────────────────────────────────────────
// // OPTION CARD
// // ─────────────────────────────────────────────────────────────────────────────
// const OptionCard = ({ emoji, label, desc, selected, onClick, badge }) => (
//   <button onClick={onClick} style={{
//     position: "relative", textAlign: "left", borderRadius: 12, padding: "12px 12px 10px",
//     // background: selected ? T.purpleLight : T.cardBg,
//     border: selected ? `2px solid ${T.purpleBorder}` : `1px solid ${T.border}`,
//     cursor: "pointer", display: "flex", flexDirection: "column", transition: "all 0.2s",
//   }}>
//     {selected && (
//       <div style={{ position: "absolute", top: 8, right: 8, width: 20, height: 20, background: T.purple700, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
//         <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
//       </div>
//     )}
//     <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//       <IconCircle size={36}>{emoji}</IconCircle>
//       <p style={{ fontWeight: 700, fontSize: 11, lineHeight: 1.3, color: T.heading, paddingRight: selected ? 20 : 0, margin: 0 }}>{label}</p>
//     </div>
//     <p style={{ fontSize: 10, lineHeight: 1.4, color: T.sub, flex: 1, margin: "0 0 6px" }}>{desc}</p>
//     {badge && <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 99, color: badge.color, background: badge.bg, alignSelf: "flex-start", marginBottom: 4 }}>{badge.label}</span>}
//     {/* <span style={{ fontSize: 11, fontWeight: 600, color: T.purple700 }}>Explore →</span> */}
//   </button>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // ADAPTIVE QUESTIONS BUILDER
// // ─────────────────────────────────────────────────────────────────────────────
// function buildAdaptiveQuestions(allData) {
//   const {
//     selectedJourney,
//     selectedRoute,
//     selectedSymptoms = [],
//     duration,
//     severity,
//     tryingToConceive,
//     urgentSymptoms = [],
//     lifeStageAnswers = {},
//     profile = {},
//   } = allData;

//   // ── Resolve stages — always prefer stored stages from lifeStageAnswers ──
//   const stages = lifeStageAnswers?.stages?.length > 0
//     ? lifeStageAnswers.stages
//     : getLifeStages(profile?.age, profile?.marital);

//   const hasStage = key => stages.includes(key);
//   const qs = [];
//   const route = selectedRoute || "";
//   const hasSym = s => selectedSymptoms.includes(s);

//   // ── LIFE-STAGE SPECIFIC ───────────────────────────────────────────────────

//   if (hasStage("adolescence")) {
//     qs.push({
//       id: "aq_first_period_age",
//       q: "How old were you when you had your first period?",
//       type: "single",
//       options: ["Under 10", "10–12", "13–15", "16+", "Haven't started yet"],
//     });
//     qs.push({
//       id: "aq_period_education",
//       q: "Have you received education or guidance about your menstrual cycle?",
//       type: "single",
//       options: ["Yes — from a doctor", "Yes — from school/family", "Somewhat", "No"],
//     });
//   }

//   if (hasStage("youngAdult")) {
//     qs.push({
//       id: "aq_contraception_use",
//       q: "Are you currently using any form of contraception?",
//       type: "single",
//       options: ["Yes — hormonal", "Yes — non-hormonal", "No", "Prefer not to say"],
//     });
//     qs.push({
//       id: "aq_pap_smear",
//       q: "When did you last have a cervical screening (Pap smear)?",
//       type: "single",
//       options: ["Within the last year", "1–3 years ago", "More than 3 years ago", "Never", "Not sure"],
//     });
//   }

//   if (hasStage("matureReproductive")) {
//     qs.push({
//       id: "aq_ovarian_reserve",
//       q: "Have you ever had your ovarian reserve (AMH) tested?",
//       type: "single",
//       options: ["Yes — normal result", "Yes — low result", "No", "Not sure what this is"],
//     });
//     qs.push({
//       id: "aq_mammogram",
//       q: "Have you had a mammogram in the past 2 years?",
//       type: "single",
//       options: ["Yes", "No — not yet due", "No — overdue", "Prefer not to say"],
//     });
//   }

//   if (hasStage("perimenopause")) {
//     qs.push({
//       id: "aq_cycle_change",
//       q: "How have your cycles changed recently?",
//       type: "single",
//       options: ["Getting shorter", "Getting longer / irregular", "Skipping months", "Heavier than before", "No noticeable change"],
//     });
//     qs.push({
//       id: "aq_vasomotor",
//       q: "Are hot flushes or night sweats disrupting your sleep?",
//       type: "single",
//       options: ["Yes — every night", "Yes — a few times a week", "Occasionally", "No"],
//     });
//   }

//   if (hasStage("menopause")) {
//     qs.push({
//       id: "aq_last_period",
//       q: "How long ago was your last menstrual period?",
//       type: "single",
//       options: ["6–12 months ago", "1–2 years ago", "More than 2 years ago", "Not sure"],
//     });
//     qs.push({
//       id: "aq_dexa_scan",
//       q: "Have you had a bone density (DEXA) scan?",
//       type: "single",
//       options: ["Yes — normal", "Yes — osteopenia or osteoporosis found", "No — not yet", "Recommended but not done"],
//     });
//   }

//   if (hasStage("postmenopause") || hasStage("geriatric")) {
//     qs.push({
//       id: "aq_cardio_history",
//       q: "Have you ever been diagnosed with a cardiovascular condition?",
//       type: "single",
//       options: ["Yes", "No", "Family history only", "Not sure"],
//     });
//     qs.push({
//       id: "aq_fall_risk",
//       q: "Do you have concerns about balance or risk of falls?",
//       type: "single",
//       options: ["Yes — I've had a fall recently", "Yes — I feel unsteady", "Somewhat", "No"],
//     });
//   }

//   // ── SYMPTOM / JOURNEY SPECIFIC ────────────────────────────────────────────

//   if (selectedJourney === "pcos" || route === "pcos_screening" || route === "menstrual_health" || hasSym("Irregular periods") || hasSym("Missed period")) {
//     qs.push({
//       id: "aq_cycle_gap",
//       q: "How many days apart are your cycles on average?",
//       type: "single",
//       options: ["Less than 21 days", "21–28 days", "29–35 days", "35–90 days", "More than 90 days / absent"],
//     });
//     qs.push({
//       id: "aq_insulin",
//       q: "Do you experience strong sugar cravings or energy crashes after meals?",
//       type: "single",
//       options: ["Frequently", "Sometimes", "Rarely", "Never"],
//     });
//   }

//   if (hasSym("Acne") || hasSym("Facial hair growth") || hasSym("Acne or excess hair growth")) {
//     qs.push({
//       id: "aq_androgen",
//       q: "Where do you mostly notice acne or unwanted hair growth?",
//       type: "multi",
//       options: ["Chin / jaw", "Upper lip", "Chest", "Back / shoulders", "Abdomen"],
//     });
//   }

//   if (hasSym("Weight gain") || hasSym("Unexplained weight gain") || hasSym("Weight gain or difficulty losing weight")) {
//     qs.push({
//       id: "aq_weight_change",
//       q: "Roughly how much weight have you gained, and over what period?",
//       type: "single",
//       options: ["Less than 3 kg (< 6 months)", "3–7 kg (6–12 months)", "More than 7 kg", "Not sure"],
//     });
//   }

//   if (tryingToConceive === "Yes" || selectedJourney === "fertility" || selectedJourney === "pregnancy" || route === "fertility" || route === "preconception" || route === "early_pregnancy") {
//     qs.push({
//       id: "aq_ttc_months",
//       q: "How long have you been actively trying to conceive?",
//       type: "single",
//       options: ["Just starting", "1–3 months", "4–6 months", "7–12 months", "More than 1 year"],
//     });
//     qs.push({
//       id: "aq_ovulation_tracking",
//       q: "Are you currently tracking ovulation?",
//       type: "single",
//       options: ["Yes — OPK / test strips", "Yes — app-based tracking", "Yes — basal body temperature", "No", "Not sure how to"],
//     });
//   }

//   if (route === "early_pregnancy" || hasSym("Nausea or vomiting") || hasSym("Missed period")) {
//     qs.push({
//       id: "aq_pregnancy_confirm",
//       q: "Have you taken a home pregnancy test?",
//       type: "single",
//       options: ["Yes — positive", "Yes — negative", "Not yet", "Unsure of result"],
//     });
//   }

//   if (route === "pelvic_pain" || hasSym("Pelvic pain") || hasSym("Pelvic pressure")) {
//     qs.push({
//       id: "aq_pain_timing",
//       q: "When is pelvic pain worst?",
//       type: "multi",
//       options: ["During menstruation", "Mid-cycle / ovulation", "During / after sex", "During bowel movement", "Constantly / unpredictable"],
//     });
//   }

//   if (route === "heavy_bleeding" || hasSym("Heavy bleeding") || hasSym("Soaking a pad or tampon every hour")) {
//     qs.push({
//       id: "aq_bleeding_impact",
//       q: "How does the bleeding affect your daily life?",
//       type: "single",
//       options: ["I avoid going out on heavy days", "I wake at night to change protection", "I've had to miss work or activities", "It's manageable with products"],
//     });
//   }

//   if (selectedJourney === "menopause" || route === "menopause_symptoms") {
//     qs.push({
//       id: "aq_hrt_interest",
//       q: "Are you open to discussing Hormone Replacement Therapy (HRT)?",
//       type: "single",
//       options: ["Already on HRT", "Open to it", "Prefer natural options only", "Would like more information first", "Not interested"],
//     });
//     qs.push({
//       id: "aq_menopause_impact",
//       q: "Which area of life is most impacted by your symptoms?",
//       type: "single",
//       options: ["Sleep", "Work / concentration", "Relationships / intimacy", "Mood", "Physical activity"],
//     });
//   }

//   if (route === "urogenital" || hasSym("Vaginal dryness") || hasSym("Urinary urgency") || hasSym("Urine leakage")) {
//     qs.push({
//       id: "aq_urogenital_impact",
//       q: "Which urogenital symptoms bother you the most?",
//       type: "multi",
//       options: ["Dryness during sex", "Urine leakage", "Urgency to urinate", "Recurrent infections", "Pelvic pressure"],
//     });
//   }

//   if (route === "infection_gynae") {
//     qs.push({
//       id: "aq_infection_type",
//       q: "Which description best matches the discharge or discomfort?",
//       type: "single",
//       options: ["White, thick, clumpy", "Grey / white, thin, fishy odour", "Yellow / green, frothy", "Clear / watery", "Uncertain / none"],
//     });
//   }

//   if (route === "contraception") {
//     qs.push({
//       id: "aq_contraception_current",
//       q: "What contraception are you currently using, if any?",
//       type: "single",
//       options: ["Combined oral pill", "Progestogen-only pill", "IUD (copper)", "IUS / hormonal coil", "Implant", "Injection", "None", "Other"],
//     });
//   }

//   if (route === "mental_wellbeing" || hasSym("Persistent low mood") || hasSym("Anxiety or worry")) {
//     qs.push({
//       id: "aq_mood_duration",
//       q: "How long have you been experiencing these mood changes?",
//       type: "single",
//       options: ["Less than 2 weeks", "2–4 weeks", "1–3 months", "More than 3 months", "On and off for years"],
//     });
//     qs.push({
//       id: "aq_mood_cycle_link",
//       q: "Do your mood symptoms seem to worsen at a particular time of your cycle?",
//       type: "single",
//       options: ["Yes — the week before my period", "Yes — during my period", "No — they're constant", "My cycle is irregular / absent", "Not sure"],
//     });
//   }

//   if (route === "bone_health") {
//     qs.push({
//       id: "aq_bone_history",
//       q: "Do you have a personal or family history of osteoporosis or fractures?",
//       type: "single",
//       options: ["Yes — personal", "Yes — family", "Both", "No", "Not sure"],
//     });
//   }

//   if (route === "lifestyle") {
//     qs.push({
//       id: "aq_lifestyle_priority",
//       q: "What aspect of your health do you most want to improve?",
//       type: "multi",
//       options: ["Weight / body composition", "Energy levels", "Sleep quality", "Stress management", "Nutrition", "Fitness"],
//     });
//   }

//   if (severity === "Severe" || severity === "Very severe") {
//     qs.push({
//       id: "aq_missed_activities",
//       q: "Have your symptoms caused you to miss work, school, or social activities?",
//       type: "single",
//       options: ["Yes — frequently", "Yes — occasionally", "No — I push through it", "No — symptoms are manageable"],
//     });
//   }

//   if (duration === "More than 1 year" || duration === "6 months to 1 year") {
//     qs.push({
//       id: "aq_prev_treatment",
//       q: "Have you tried any treatments or medications for this so far?",
//       type: "multi",
//       options: ["Over-the-counter pain relief", "Hormonal contraception", "Prescription medication", "Dietary / lifestyle changes", "Herbal / supplements", "Nothing yet"],
//     });
//   }

//   if (urgentSymptoms.length > 0 && !urgentSymptoms.includes("None of these")) {
//     qs.push({
//       id: "aq_urgent_started",
//       q: "How long ago did these urgent symptoms start?",
//       type: "single",
//       options: ["Within the last hour", "Today", "Yesterday", "2–3 days ago", "More than 3 days ago"],
//     });
//   }

//   // ── Universal closing questions ───────────────────────────────────────────
//   qs.push({
//     id: "aq_mood_overall",
//     q: "Over the past 2 weeks, how has your overall mood been?",
//     type: "single",
//     options: ["Mostly positive", "Neutral / okay", "Frequently low or anxious", "Very difficult — struggling"],
//   });
//   qs.push({
//     id: "aq_support",
//     q: "Do you have a support system you can talk to about your health?",
//     type: "single",
//     options: ["Yes — partner / family", "Yes — close friends", "Somewhat", "Not really", "I prefer handling things privately"],
//   });

//   const seen = new Set();
//   return qs.filter(q => {
//     if (seen.has(q.id)) return false;
//     seen.add(q.id);
//     return true;
//   }).slice(0, 8);
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 5 — Height & Weight
// // ─────────────────────────────────────────────────────────────────────────────
// // export function HeightWeightScreen({ onNext, onBack }) {
// //   const [heightIn, setHeightIn] = useState(64);
// //   const [weightKg, setWeightKg] = useState(60);

// //   const ft = Math.floor(heightIn / 12);
// //   const in_ = heightIn % 12;
// //   const bmi = (weightKg / ((heightIn * 0.0254) ** 2)).toFixed(1);
// //   const bmiCategory = bmi < 18.5 ? "Underweight" : bmi < 25 ? "Normal" : bmi < 30 ? "Overweight" : "Obese";
// //   const bmiColor = bmi < 18.5 ? T.amber : bmi < 25 ? T.green : bmi < 30 ? T.amber : T.red;

// //   const SliderRow = ({ label, value, min, max, onChange, display }) => (
// //     <div style={{ marginBottom: 14 }}>
// //       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
// //         <label style={{ fontSize: 11, fontWeight: 700, color: T.heading }}>{label}</label>
// //         <span style={{ fontSize: 13, fontWeight: 700, color: T.purple700 }}>{display}</span>
// //       </div>
// //       <input type="range" min={min} max={max} value={value} onChange={e => onChange(Number(e.target.value))}
// //         style={{ width: "100%", accentColor: T.purple700, height: 4 }} />
// //       <div style={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
// //         <span style={{ fontSize: 10, color: T.muted }}>{min}</span>
// //         <span style={{ fontSize: 10, color: T.muted }}>{max}</span>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <PageWrap>
// //       <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 12 }}>
// //         <div>
// //           <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>Height & Weight</h1>
// //           <p style={{ fontSize: 11, color: T.sub, margin: 0 }}>Used to calculate your BMI and personalize recommendations.</p>
// //         </div>
// //         <div style={{ fontSize: 60, marginTop: -8, flexShrink: 0, userSelect: "none" }}>⚖️</div>
// //       </div>
// //       <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
// //         <div style={{ flex: 1 }}>
// //           <div style={{ background: "#fff", borderRadius: 12, padding: 16, border: `1px solid ${T.border}` }}>
// //             <SliderRow label="Height" value={heightIn} min={48} max={84} onChange={setHeightIn} display={`${ft}.${in_ === 0 ? "0" : in_} Ft`} />
// //             <SliderRow label="Weight" value={weightKg} min={30} max={150} onChange={setWeightKg} display={`${weightKg} Kg`} />
// //             <div style={{ background: "#F9FAFB", border: `1.5px solid ${T.border}`, borderRadius: 10, padding: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
// //               <div>
// //                 <p style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>Your BMI</p>
// //                 <p style={{ fontSize: 32, fontWeight: 700, color: bmiColor, margin: 0 }}>{bmi}</p>
// //               </div>
// //               <div style={{ textAlign: "right" }}>
// //                 <span style={{ padding: "4px 12px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: bmiColor + "22", color: bmiColor }}>{bmiCategory}</span>
// //                 <p style={{ fontSize: 10, color: T.muted, margin: "6px 0 0" }}>Based on WHO standards</p>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //         <div style={{ width: 220, flexShrink: 0 }}>
// //           <RightCard>
// //             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>Why BMI matters</p>
// //             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>BMI is a useful screening tool, but just one part of the picture. We combine it with your life stage and symptoms for a holistic view.</p>
// //             {[
// //               { label: "Underweight", range: "< 18.5",      color: T.amber },
// //               { label: "Normal",      range: "18.5 – 24.9", color: T.green },
// //               { label: "Overweight",  range: "25 – 29.9",   color: T.amber },
// //               { label: "Obese",       range: "≥ 30",         color: T.red   },
// //             ].map(b => (
// //               <div key={b.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 10px", borderRadius: 6, background: b.label === bmiCategory ? b.color + "20" : "transparent" }}>
// //                 <span style={{ fontSize: 10, fontWeight: b.label === bmiCategory ? 700 : 400, color: b.label === bmiCategory ? b.color : T.sub }}>{b.label}</span>
// //                 <span style={{ fontSize: 10, color: T.muted }}>{b.range}</span>
// //               </div>
// //             ))}
// //           </RightCard>
// //         </div>
// //       </div>
// //       <FooterBar
// //         left={<BtnBack onClick={onBack} />}
// //         center={null}
// //         right={<BtnContinue onClick={() => {
// //           const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
// //           localStorage.setItem("patientPersona", JSON.stringify({ ...existing, heightIn, weightKg, bmi, savedAt: Date.now() }));
// //           onNext({ heightIn, weightKg, bmi });
// //         }} label="Save & Continue" />}
// //       />
// //     </PageWrap>
// //   );
// // }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 6 — Basic Life Stage Questions
// // ─────────────────────────────────────────────────────────────────────────────
// // export function BasicLifeStageScreen({ onNext, onBack, profile = {}, initialValues = {} }) {
// //   const [answers, setAnswers] = useState(initialValues || {});
// //   const [lmp, setLmp] = useState(initialValues?.lmp || "");
// //   const [deliveryDate, setDelivery] = useState(initialValues?.deliveryDate || "");

// //   const setAns = (key, val) => setAnswers(p => ({ ...p, [key]: val }));

// //   // ── Dynamically resolve stages from profile ──
// //   const stages   = getLifeStages(profile?.age, profile?.marital);
// //   const questions = getVisibleQuestions(stages);

// //   // ── Life stage display info ──
// //   const { stageMeta, stageName, journeyTitle, journeyEmoji } = resolveLifeStageFromProfile(profile);

// //   return (
// //     <PageWrap>
// //       <div style={{ marginBottom: 10 }}>
// //         <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>Basic Life-Stage Questions</h1>
// //         <p style={{ fontSize: 11, color: T.sub, margin: "0 0 8px" }}>
// //           Help us understand your current life stage so we can guide you to the right care path. ⏱️ About 1 minute
// //         </p>
// //         {/* Dynamic stage badge */}
// //         <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: stageMeta.color || T.purpleTag, borderRadius: 20, padding: "3px 10px", fontSize: 10, fontWeight: 600, color: T.purple700 }}>
// //           {stageMeta.emoji} {stages.map(formatStageLabel).join(" · ")}
// //         </div>
// //       </div>

// //       <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
// //         <div style={{ flex: 1 }}>
// //           <div style={{ background: "#fff", borderRadius: 12, padding: "4px 14px", border: `1px solid ${T.border}` }}>
// //             {questions
// //               .filter(q => {
// //                 if (q.key === "trying_pregnant" && answers["currently_pregnant"] === "Yes") return false;
// //                 return true;
// //               })
// //               .map((q, idx, visibleQs) => (
// //                 <div key={q.key} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: idx < visibleQs.length - 1 ? `1px solid ${T.border}` : "none" }}>
// //                   <div style={{ width: 26, height: 26, background: T.purple700, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#fff", flexShrink: 0 }}>{q.num}</div>
// //                   <div style={{ flex: 1, minWidth: 0 }}>
// //                     <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: 0 }}>{q.q}</p>
// //                     <p style={{ fontSize: 10, color: T.muted, margin: 0 }}>{q.desc}</p>
// //                   </div>
// //                   {q.type === "yesno" && (
// //                     <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
// //                       <YesNoBtn label="Yes" active={answers[q.key] === "Yes"} onClick={() => setAns(q.key, "Yes")} />
// //                       <YesNoBtn label="No"  active={answers[q.key] === "No"}  onClick={() => setAns(q.key, "No")} />
// //                     </div>
// //                   )}
// //                   {q.type === "date" && (
// //                     <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
// //                       <input type="date"
// //                         value={q.key === "lmp" ? lmp : deliveryDate}
// //                         onChange={e => q.key === "lmp" ? setLmp(e.target.value) : setDelivery(e.target.value)}
// //                         style={{ border: `1.5px solid ${T.border}`, borderRadius: 8, padding: "5px 10px", fontSize: 11, outline: "none", color: T.heading }} />
// //                       <span style={{ color: T.muted, fontSize: 14 }}>📅</span>
// //                     </div>
// //                   )}
// //                 </div>
// //               ))}
// //           </div>
// //         </div>

// //         <div style={{ width: 220, flexShrink: 0 }}>
// //           <RightCard>
// //             <div style={{ display: "flex", justifyContent: "center" }}>
// //               <div style={{ width: 80, height: 80, background: stageMeta.color || "#FFF0F3", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48, userSelect: "none" }}>
// //                 {stageMeta.emoji}
// //               </div>
// //             </div>
// //             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>Why we ask these questions</p>
// //             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
// //               Your answers help us understand your current life stage and provide personalized care recommendations.
// //             </p>
// //             {/* Dynamic life stage display */}
// //             <div style={{ background: stageMeta.color || T.lavenderBg, borderRadius: 8, padding: "8px 10px" }}>
// //               <p style={{ fontSize: 10, fontWeight: 600, color: T.heading, margin: "0 0 5px" }}>Your detected life stage</p>
// //               <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
// //                 {stages.map(s => (
// //                   <span key={s} style={{ fontSize: 10, background: T.purpleTag, color: T.purple700, borderRadius: 20, padding: "2px 8px", fontWeight: 600 }}>
// //                     {stageMeta.emoji} {formatStageLabel(s)}
// //                   </span>
// //                 ))}
// //               </div>
// //             </div>
// //             <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", gap: 6, alignItems: "flex-start" }}>
// //               <span style={{ fontSize: 14 }}>🔒</span>
// //               <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>Your data is protected with industry-standard encryption.</p>
// //             </div>
// //           </RightCard>
// //         </div>
// //       </div>

// //       <FooterBar
// //         left={<BtnBack onClick={onBack} />}
// //         center={<FooterNote>Your data is secure and encrypted</FooterNote>}
// //         right={<BtnContinue onClick={() => onNext({ ...answers, lmp, deliveryDate, stages })} />}
// //       />
// //     </PageWrap>
// //   );
// // }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 7 — Entry Reason
// // ─────────────────────────────────────────────────────────────────────────────
// export function EntryReasonScreen({ profile, onNext, onBack, initialSelected = [], stepIndex, totalSteps }) {
//   const [selected, setSelected] = useState(initialSelected);

//   // ── Dynamically resolve journey from profile ──
//   const { stages, stageMeta, stageName, journey } = resolveLifeStageFromProfile(profile);
//   const toggle = val => setSelected(p => p.includes(val) ? p.filter(v => v !== val) : [...p, val]);

//   const getUrgencyBadge = route => {
//     if (!route) return null;
//     if (route.toLowerCase().includes("urgent") || route.toLowerCase().includes("triage"))
//       return { label: "Urgent", color: T.red, bg: "#FEF2F2" };
//     return null;
//   };

//   const selectedRoute = journey?.options?.find(o => selected.includes(o.value))?.route || null;

//   return (
//     <>
//       {/* <PageWrap> */}
//       <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
//         <div style={{ maxWidth: 480 }}>
//           <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>
//             {journey?.screenTitle || "What brings you in today?"}
//           </h1>
//           <p style={{ fontSize: 11, color: T.sub, marginBottom: 8 }}>
//             Based on your life stage, choose the option that best matches your concern.
//           </p>
//           {/* Dynamic stage badge */}
//           <StageBadge label={journey?.journeyTitle || stageName} emoji={stageMeta.emoji} />
//         </div>
//         <StepperProgress current={stepIndex} total={totalSteps} />
//         {/* <div style={{ fontSize: 64, marginTop: -8, flexShrink: 0, userSelect: "none" }}>📱</div> */}
//       </div>

//       <div style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", border: `1px solid ${T.border}` }}>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
//           {(journey?.options || []).map(opt => (
//             <OptionCard
//               key={opt.value}
//               emoji={opt.emoji}
//               label={opt.label}
//               desc={opt.desc}
//               selected={selected.includes(opt.value)}
//               onClick={() => toggle(opt.value)}
//               badge={getUrgencyBadge(opt.route)}
//             />
//           ))}
//         </div>
//         {/* <TrustBar /> */}
//       </div>
// {/* <BtnBack variant="outline" onClick={onBack}/>
// <BtnContinue variant="primary" disabled={!canContinue}
//             onClick={handleContinue} label="Continue"/> */}
//       <FooterBar
//         left={<BtnBack variant="outline" onClick={onBack} />}
//         center={
//           <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
//             <BtnAskNavigator onClick={() => { }} />
//             <FooterNote>You can change your response later.</FooterNote>
//           </div>
//         }
//         right={<BtnContinue variant="primary"  label="Continue" disabled={selected.length === 0} onClick={() => onNext({ selectedReasons: selected, selectedRoute })} />}
//       />
//       {/* </PageWrap> */}
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 8 — Condition Specific Intake
// // ─────────────────────────────────────────────────────────────────────────────
// export function ConditionSpecificIntakeScreen({ onNext, onBack, stepIndex, totalSteps, selectedRoute, selectedJourney, profile, lifeStageAnswers = {}, initialValues = {} }) {
//   const [selectedSymptoms, setSelectedSymptoms] = useState(initialValues.selectedSymptoms || []);
//   const [duration, setDuration] = useState(initialValues.duration || "");
//   const [severity, setSeverity] = useState(initialValues.severity || "");
//   const [tryingToConceive, setTryingToConceive] = useState(initialValues.tryingToConceive || "");

//   const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();
//   const route = selectedRoute || "pcos_screening";

//   // ── Dynamically resolve life stage from profile ──
//   const { stages, stageMeta, stageName, journey, journeyTitle, journeyEmoji } =
//     resolveLifeStageFromProfile(profile, lifeStageAnswers);

//   const ROUTE_META = {
//     menstrual_health: { title: "Tell us about your menstrual health", desc: "Help us understand your cycle and symptoms." },
//     pcos_screening: { title: "Tell us about your hormonal symptoms", desc: "We'll use your answers to check for PCOS indicators." },
//     pelvic_pain: { title: "Tell us about your pelvic pain", desc: "Describe where and when you feel pain." },
//     menopause_symptoms: { title: "Tell us about your menopause symptoms", desc: "Help us understand which symptoms affect you most." },
//     infection_gynae: { title: "Tell us about your discharge or discomfort", desc: "Your answers help us identify the likely cause." },
//     early_pregnancy: { title: "Tell us about your early pregnancy symptoms", desc: "Help us understand what you are experiencing." },
//     preconception: { title: "Tell us about your preconception concerns", desc: "We'll tailor guidance to your pregnancy planning goals." },
//     fertility: { title: "Tell us about your fertility journey", desc: "Help us understand your conception experience so far." },
//     heavy_bleeding: { title: "Tell us about your bleeding", desc: "Describe how heavy or irregular your bleeding has been." },
//     urogenital: { title: "Tell us about your urogenital symptoms", desc: "Help us understand your pelvic floor and urinary concerns." },
//     bone_health: { title: "Tell us about your bone and heart health", desc: "We'll help you plan preventive screening." },
//     mental_wellbeing: { title: "Tell us about your mood and wellbeing", desc: "Your answers help us connect you with the right support." },
//     contraception: { title: "Tell us about your contraception needs", desc: "We'll help you find the right option for your situation." },
//     puberty_education: { title: "Tell us about your puberty concerns", desc: "Help us understand what you'd like guidance on." },
//     lifestyle: { title: "Tell us about your lifestyle concerns", desc: "We'll tailor wellness recommendations to your goals." },
//     preventive_care: { title: "Tell us about your wellness needs", desc: "Help us plan your preventive care checklist." },
//     chronic_disease: { title: "Tell us about your ongoing health concerns", desc: "We'll help coordinate your chronic condition care." },
//   };

//   const meta = ROUTE_META[route] || { title: "Tell us a bit more about your symptoms", desc: "We'll use your answers to personalise your next steps." };
//   const symptoms = SYMPTOM_MAP[route] || SYMPTOM_MAP["pcos_screening"];

//   const DURATION_OPTS = ["Less than 1 month", "1–3 months", "3–6 months", "6 months to 1 year", "More than 1 year"];
//   const SEVERITY_OPTS = ["Mild", "Moderate", "Severe", "Very severe"];

//   const toggleSymptom = s => setSelectedSymptoms(prev => prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]);

//   const showTryingConceive = !["bone_health", "mental_wellbeing", "contraception", "puberty_education", "lifestyle", "preventive_care", "chronic_disease", "urogenital", "infection_gynae", "menopause_symptoms", "heavy_bleeding"].includes(route);

//   return (
//     <>
//       {/* <PageWrap> */}
//       {/* Dynamic stage tag */}
//       <div ref={scrollRef} style={{height:"84vh", overflow:"scroll"}}>
//       <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: stageMeta.color || T.purpleTag, borderRadius: 20, padding: "4px 12px", marginBottom: 14, fontSize: 11, fontWeight: 600, color: T.purple700 }}>
//         {stageMeta.emoji} {stageName}
//       </div>

//       <div style={{ marginBottom: 18, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//         <div style={{ maxWidth: 560 }}>
//           <h1 style={{ fontSize: 22, fontWeight: 700, color: T.heading, marginBottom: 6, lineHeight: 1.2 }}>{meta.title}</h1>
//           <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>{meta.desc}</p>
//         </div>
//         <StepperProgress current={stepIndex} total={totalSteps} />
//       </div>

//       <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
//         <div style={{ flex: 1, minWidth: 0 }}>
//           <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: `1px solid ${T.border}`, marginBottom: 14 }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
//               <div>
//                 <p style={{ fontWeight: 700, fontSize: 13, color: T.heading, margin: 0, marginBottom: 2 }}>What symptoms are you experiencing?</p>
//                 <p style={{ fontSize: 11, color: T.muted, margin: 0 }}>Select all that apply.</p>
//               </div>
//               <button style={{ display: "flex", alignItems: "center", gap: 5, padding: "5px 12px", borderRadius: 20, border: `1.5px solid ${T.border}`, background: "#fff", fontSize: 11, color: T.sub, cursor: "pointer", fontWeight: 500, flexShrink: 0 }}>
//                 ℹ️ Why we ask
//               </button>
//             </div>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginTop: 14 }}>
//               {symptoms.map(s => (
//                 <SymptomChip key={s} label={s} selected={selectedSymptoms.includes(s)} onClick={() => toggleSymptom(s)} />
//               ))}
//             </div>
//           </div>

//           <div style={{ display: "grid", gridTemplateColumns: showTryingConceive ? "1fr 1fr" : "1fr", gap: 12 }}>
//             <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${T.border}` }}>
//               <p style={{ fontSize: 12, fontWeight: 600, color: T.heading, marginBottom: 8 }}>How long has this been happening?</p>
//               <StyledSelect value={duration} onChange={setDuration} options={DURATION_OPTS} placeholder="Select duration" />
//             </div>
//             <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${T.border}` }}>
//               <p style={{ fontSize: 12, fontWeight: 600, color: T.heading, marginBottom: 8 }}>How severe are your symptoms? <span style={{ fontSize: 10, color: T.muted, fontWeight: 400 }}>ℹ️</span></p>
//               <StyledSelect value={severity} onChange={setSeverity} options={SEVERITY_OPTS} placeholder="Select severity" />
//             </div>
//           </div>
//         </div>

//         {/* Sidebar — fully dynamic journey info */}
//         <div style={{ width: 230, flexShrink: 0 }}>
//           <RightCard>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//               <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, margin: 0 }}>Your journey</p>
//               {/* <button style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: T.purple700, background: "none", border: "none", cursor: "pointer", fontWeight: 500 }}>Edit ✏️</button> */}
//             </div>

//             {/* Dynamic journey card */}
//             <div style={{ display: "flex", alignItems: "center", gap: 10, background: stageMeta.color || T.lavenderBg, borderRadius: 10, padding: "10px 12px" }}>
//               <div style={{ width: 44, height: 44, borderRadius: 10, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>
//                 {journeyEmoji}
//               </div>
//               <p style={{ fontWeight: 700, fontSize: 11, color: T.heading, margin: 0, lineHeight: 1.3 }}>{journeyTitle}</p>
//             </div>

//             {/* Dynamic stage badge */}
//             {/* <div style={{ display: "flex", alignItems: "center", gap: 6, background: T.purpleTag, borderRadius: 8, padding: "6px 10px" }}>
//               <span style={{ fontSize: 14 }}>{stageMeta.emoji}</span>
//               <div>
//                 <p style={{ fontSize: 10, fontWeight: 700, color: T.purple700, margin: 0 }}>{stageName}</p>
//                 <p style={{ fontSize: 9, color: T.muted, margin: 0 }}>
//                   {stages.map(formatStageLabel).join(" · ")}
//                 </p>
//               </div>
//             </div> */}

//             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>We'll personalise your care plan based on your responses.</p>

//             {/* <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
//               <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 6 }}>Current step</p>
//               <div style={{ background: T.purple700, color: "#fff", borderRadius: 20, padding: "3px 10px", fontSize: 11, fontWeight: 700, display: "inline-block" }}>8 of 11</div>
//               <p style={{ fontSize: 10, color: T.muted, margin: "4px 0 0" }}>Condition-Specific Intake</p>
//             </div> */}

//             <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
//               <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 2 }}>Est. time to complete</p>
//               <p style={{ fontSize: 11, color: T.sub, margin: 0 }}>~5 min</p>
//             </div>

//             {selectedSymptoms.length > 0 && (
//               <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
//                 <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 6 }}>Your responses</p>
//                 <p style={{ fontSize: 11, color: T.sub, margin: "0 0 8px" }}>{selectedSymptoms.length} symptom{selectedSymptoms.length > 1 ? "s" : ""} selected</p>
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: 6,fontSize:"12px" }}>
//                   {/* {selectedSymptoms.slice(0, 5).map(s => (
//                     <div key={s} style={{ width: 30, height: 30, borderRadius: 8, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }} title={s}>
//                       {SYMPTOM_ICONS[s] || "•"}
//                     </div>
//                   ))} */}
                 
//                   {selectedSymptoms.map((item,index)=>(
//                     <p key={index}>{item}</p>
//                   ))}
                  
//                   {selectedSymptoms.length > 5 && (
//                     <div style={{ width: 30, height: 30, borderRadius: 8, background: T.purpleTag, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: T.purple700 }}>
//                       +{selectedSymptoms.length - 5}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "center", gap: 8 }}>
//               <span style={{ fontSize: 18 }}>🔒</span>
//               <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>Your answers are private and securely encrypted.</p>
//             </div> */}
//           </RightCard>
//         </div>
//       </div>
// {/* <BtnBack variant="outline" onClick={onBack}/>
// <BtnContinue variant="primary" disabled={!canContinue}
//             onClick={handleContinue} label="Continue"/> */}
//       <FooterBar
//         left={<BtnBack onClick={onBack} variant="outline"  />}
//         center={<FooterNote>Your responses help personalise your care journey</FooterNote>}
//         right={<BtnContinue variant="primary" label="Continue" disabled={selectedSymptoms.length === 0} onClick={() => onNext({ selectedSymptoms, duration, severity, tryingToConceive })} />}
//       />
//          {showButton && (
//               <ScrollToBottomButton onClick={scrollToBottom} />
//             )}
//       </div>
//       {/* </PageWrap> */}
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 9 — Safety Check
// // ─────────────────────────────────────────────────────────────────────────────
// export function SafetyCheckScreen({ onNext, onBack, initialSelected = [], stepIndex, totalSteps }) {
//   const [selected, setSelected] = useState(initialSelected);
// const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();
//   const toggle = label => {
//     if (label === "None of these") { setSelected(["None of these"]); return; }
//     setSelected(prev => {
//       const without = prev.filter(x => x !== "None of these");
//       return without.includes(label) ? without.filter(x => x !== label) : [...without, label];
//     });
//   };

//   const hasUrgent = selected.length > 0 && !selected.includes("None of these");
//   const URGENCY = hasUrgent
//     ? { concern: "Possible urgent symptoms reported", action: "Priority review needed", response: "We may guide you to same-day care", concernColor: T.red, actionColor: T.amber, responseColor: T.purple700 }
//     : { concern: "No urgent symptoms reported", action: "Standard care pathway", response: "We'll guide you through personalized care", concernColor: T.green, actionColor: T.green, responseColor: T.purple700 };

//   return (
//     <>
//     <div ref={scrollRef} style={{height:"84vh", overflow:"scroll"}}>
//       {/* <PageWrap> */}
//       <div className="scj-header">
//         {/* <div style={{ width: 60, height: 60, borderRadius: "50%", background: hasUrgent ? "#FEE2E2" : T.pinkLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, margin: "0 auto 12px", border: `2px solid ${hasUrgent ? "#FCA5A5" : T.pinkBorder}` }}>
//           {hasUrgent ? "⚠️" : "🛡️"}
//         </div> */}
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 6 }}>Before we continue, let's make sure you're safe</h1>
//           <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>Please tell us if you are experiencing any urgent symptoms right now.</p>
//         </div>
//         <StepperProgress current={stepIndex} total={totalSteps} />
//       </div>

//       <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
//         <div style={{ flex: 1 }}>
//           <div style={{ background: "#fff", borderRadius: 14, padding: 16, border: `1px solid ${T.border}`, marginBottom: 14 }}>
//             <p style={{ fontWeight: 700, fontSize: 13, color: T.heading, marginBottom: 4 }}>Are you currently experiencing any of these?</p>
//             <p style={{ fontSize: 11, color: T.muted, marginBottom: 14 }}>Select all that apply.</p>
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
//               {SAFETY_SYMPTOMS.map(({ label, icon }) => {
//                 const isSel = selected.includes(label);
//                 const isNone = label === "None of these";
//                 const isUrg = isSel && !isNone;
//                 return (
//                   <button key={label} onClick={() => toggle(label)} style={{
//                     display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, cursor: "pointer", textAlign: "left", transition: "all 0.15s",
//                     border: isSel ? `2px solid ${isUrg ? "#FCA5A5" : isNone ? T.green : T.purpleBorder}` : `1.5px solid ${T.border}`,
//                     background: isSel ? isUrg ? "#FEF2F2" : isNone ? "#ECFDF5" : T.purpleLight : "#fff",
//                   }}>
//                     <div style={{ width: 32, height: 32, borderRadius: 8, background: isSel ? isUrg ? "#FEE2E2" : isNone ? "#D1FAE5" : T.purpleLight : "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{icon}</div>
//                     <span style={{ fontSize: 12, fontWeight: isSel ? 600 : 400, color: isSel ? isUrg ? "#991B1B" : isNone ? "#065F46" : T.purple700 : T.body, flex: 1 }}>{label}</span>
//                     <div style={{ width: 18, height: 18, borderRadius: 4, border: isSel ? "none" : `1.5px solid ${T.border}`, background: isSel ? isUrg ? T.red : isNone ? T.green : T.purple700 : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                       {isSel && <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}
//                     </div>
//                   </button>
//                 );
//               })}
//             </div>
//             <div style={{ marginTop: 12, display: "flex", alignItems: "flex-start", gap: 8, background: T.infoBg, borderRadius: 8, padding: "8px 10px", border: `1px solid ${T.infoBorder}` }}>
//               <span style={{ fontSize: 14, flexShrink: 0 }}>ℹ️</span>
//               <p style={{ fontSize: 10, color: T.infoText, margin: 0, lineHeight: 1.5 }}>If you are pregnant, postpartum, or have severe symptoms, our care team may recommend urgent evaluation.</p>
//             </div>
//           </div>

//           <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${hasUrgent ? "#FCA5A5" : T.border}` }}>
//             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, marginBottom: 10 }}>Urgency Check</p>
//             {[
//               { icon: "⚠️", label: "Current concern", value: URGENCY.concern, color: URGENCY.concernColor },
//               { icon: "🔶", label: "Suggested action", value: URGENCY.action, color: URGENCY.actionColor },
//               { icon: "💜", label: "Care team response", value: URGENCY.response, color: URGENCY.responseColor },
//             ].map(row => (
//               <div key={row.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${T.border}` }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                   <span style={{ fontSize: 14 }}>{row.icon}</span>
//                   <span style={{ fontSize: 11, color: T.body, fontWeight: 500 }}>{row.label}</span>
//                 </div>
//                 <span style={{ fontSize: 11, fontWeight: 600, color: row.color, textAlign: "right", maxWidth: 200 }}>{row.value}</span>
//               </div>
//             ))}
//             {hasUrgent && (
//               <div style={{ marginTop: 10, display: "flex", alignItems: "flex-start", gap: 8, background: "#FFFBEB", borderRadius: 8, padding: "8px 10px", border: `1px solid #FDE68A` }}>
//                 <span style={{ fontSize: 14 }}>⚠️</span>
//                 <p style={{ fontSize: 10, color: "#92400E", margin: 0, lineHeight: 1.5 }}>This screen does not provide a diagnosis. If symptoms are severe, seek urgent medical care.</p>
//               </div>
//             )}
//           </div>
//         </div>

//         <div style={{ width: 230, flexShrink: 0 }}>
//           <RightCard>
//             <div style={{ textAlign: "center", fontSize: 48 }}>🛡️</div>
//              {/* <img src='/images/secureProfile.svg' className="h-20 w-20" /> */}
//             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, textAlign: "center" }}>Your safety comes first</p>
//             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0, textAlign: "center" }}>This quick check helps us identify if you need immediate attention before proceeding.</p>
//             <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
//               {[
//                 { icon: "🚨", title: "Urgent symptoms", desc: "We may direct you to same-day or emergency care." },
//                 { icon: "🩺", title: "Non-urgent", desc: "We'll continue personalizing your care journey." },
//                 { icon: "🔒", title: "Secure & Private", desc: "Reviewed only by authorized care team members." },
//               ].map(f => (
//                 <div key={f.title} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 10 }}>
//                   <div style={{ width: 30, height: 30, borderRadius: 8, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>{f.icon}</div>
//                   <div>
//                     <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: "0 0 2px" }}>{f.title}</p>
//                     <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{f.desc}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div style={{ textAlign: "center", fontSize: 10, color: T.muted, paddingTop: 4, borderTop: `1px solid ${T.border}` }}>🔒 Secure · Private · Reviewed by care team</div>
//           </RightCard>
//         </div>
//       </div>
//  {/* <BtnBack variant="outline" onClick={onBack}/>
// <BtnContinue variant="primary" disabled={!canContinue}
//             onClick={handleContinue} label="Continue"/> */}
//       <FooterBar
//         left={<BtnBack variant="outline" onClick={onBack} />}
//         center={null}
//         right={<BtnContinue variant="primary" label={hasUrgent ? "⚠️ Continue — I Understand" : "Continue"} color={hasUrgent ? T.red : T.purpleBtn} disabled={selected.length === 0} onClick={() => onNext({ urgentSymptoms: selected, hasUrgent })} />}
//       />
//       {/* </PageWrap> */}
//          {showButton && (
//               <ScrollToBottomButton onClick={scrollToBottom} />
//             )}
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SCREEN 10 — Adaptive Questionnaire
// // ─────────────────────────────────────────────────────────────────────────────
// export function AdaptiveQuestionnaireScreen({ onNext, onBack, allData = {}, totalSteps, stepIndex }) {
//   const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();
//   const questions = buildAdaptiveQuestions(allData);
//   // const [answers, setAnswers] = useState({});
//   const [answers, setAnswers] = useState(allData?.adaptiveAnswers || {});
//   const [page, setPage] = useState(0);

//   // ── Dynamically resolve life stage ──
//   const { stages, stageMeta, stageName, stageDetail } =
//     resolveLifeStageFromProfile(allData?.profile || {}, allData?.lifeStageAnswers || {});

//   const PER_PAGE = 4;
//   const totalPages = Math.ceil(questions.length / PER_PAGE);
//   const pageQs = questions.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

//   const setAns = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));
//   const toggleAns = (id, val) => setAnswers(prev => {
//     const cur = prev[id] || [];
//     return { ...prev, [id]: cur.includes(val) ? cur.filter(x => x !== val) : [...cur, val] };
//   });

//   const pageAnswered = pageQs.every(q => {
//     const a = answers[q.id];
//     return q.type === "multi" ? a && a.length > 0 : !!a;
//   });

//   const answered = questions.filter(q => !!answers[q.id] && (q.type !== "multi" || answers[q.id]?.length > 0)).length;
//   const progressPct = Math.round((answered / questions.length) * 100);

//   const handleNext = () => {
//     if (page < totalPages - 1) setPage(p => p + 1);
//     else onNext(answers);
//   };

//   return (
//     <>
//       {/* <PageWrap> */}
//       {/* Dynamic stage tag */}
//      <div ref={scrollRef} style={{height:"84vh", overflow:"scroll"}}>
//  <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: stageMeta.color || T.purpleTag, borderRadius: 20, padding: "4px 12px", marginBottom: 14, fontSize: 11, fontWeight: 600, color: T.purple700 }}>
//         {stageMeta.emoji} Adaptive Questionnaire · {stageName}
//       </div>

//       <div style={{ marginBottom: 18, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//         <div style={{ maxWidth: 560 }}>
//           <h1 style={{ fontSize: 22, fontWeight: 700, color: T.heading, marginBottom: 6 }}>A few more personalised questions</h1>
//           <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>Based on your responses, we've tailored these questions to build the most accurate care plan for you.</p>
//         </div>
//         <StepperProgress current={stepIndex} total={totalSteps} />
//         {/* <div style={{ fontSize: 56, userSelect: "none", marginTop: -8 }}>🎯</div> */}
//       </div>

//       <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
//         <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 14 }}>
//           {pageQs.map((question, idx) => {
//             const val = answers[question.id];
//             const globalIdx = page * PER_PAGE + idx;
//             return (
//               <div key={question.id} style={{ background: "#fff", borderRadius: 14, padding: 18, border: `1px solid ${val ? T.purpleBorder : T.border}`, transition: "border-color 0.2s" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
//                   <div style={{ width: 28, height: 28, borderRadius: "50%", background: val ? T.purple700 : T.purpleLight, color: val ? "#fff" : T.purple700, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0, transition: "all 0.2s" }}>
//                     {val ? "✓" : globalIdx + 1}
//                   </div>
//                   <p style={{ fontSize: 13, fontWeight: 600, color: T.heading, margin: 0, lineHeight: 1.3 }}>{question.q}</p>
//                   {question.type === "multi" && <span style={{ fontSize: 10, color: T.muted, background: "#F3F4F6", borderRadius: 4, padding: "2px 6px", flexShrink: 0 }}>Multi-select</span>}
//                 </div>
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//                   {question.options.map(opt => {
//                     const active = question.type === "multi" ? (val || []).includes(opt) : val === opt;
//                     return (
//                       <button key={opt} onClick={() => question.type === "multi" ? toggleAns(question.id, opt) : setAns(question.id, opt)} style={{
//                         padding: "8px 16px", borderRadius: 8, fontSize: 12, cursor: "pointer", transition: "all 0.15s",
//                         border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//                         background: active ? T.purpleLight : "#fff",
//                         color: active ? T.purple700 : T.sub,
//                         fontWeight: active ? 600 : 400,
//                       }}>
//                         {opt}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Sidebar */}
//         <div style={{ width: 220, flexShrink: 0 }}>
//           <RightCard>
//             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, marginBottom: 2 }}>Your progress</p>
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "8px 0" }}>
//               <div style={{ width: 80, height: 80, borderRadius: "50%", background: T.purpleLight, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: `4px solid ${T.purple700}` }}>
//                 <span style={{ fontSize: 20, fontWeight: 800, color: T.purple700 }}>{progressPct}%</span>
//                 <span style={{ fontSize: 9, color: T.muted }}>complete</span>
//               </div>
//             </div>

//             {/* Dynamic life stage banner */}
//             {/* {stageDetail && (
//               <div style={{ background: stageMeta.color || T.lavenderBg, borderRadius: 8, padding: "8px 10px" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
//                   <span style={{ fontSize: 16 }}>{stageMeta.emoji}</span>
//                   <p style={{ fontWeight: 700, fontSize: 10, color: T.heading, margin: 0 }}>{stageDetail.name}</p>
//                 </div>
//                 <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{stageDetail.development}</p>
//               </div>
//             )} */}

//             {/* Questions tracker */}
//             <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
//               <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 6 }}>Questions answered</p>
//               {questions.map((q, i) => {
//                 const ans = !!answers[q.id] && (q.type !== "multi" || answers[q.id]?.length > 0);
//                 return (
//                   <div key={q.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                     <div style={{ width: 18, height: 18, borderRadius: "50%", background: ans ? T.green : T.border, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, flexShrink: 0, transition: "background 0.3s" }}>
//                       {ans && <svg width="8" height="7" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>}
//                     </div>
//                     <p style={{ fontSize: 10, color: ans ? T.heading : T.muted, margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: ans ? 600 : 400 }}>
//                       Q{i + 1}: {q.q.slice(0, 28)}…
//                     </p>
//                   </div>
//                 );
//               })}
//             </div>

//             <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "flex-start", gap: 6 }}>
//               <span style={{ fontSize: 14 }}>🎯</span>
//               <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>These questions were selected based on your life stage, symptoms and journey type.</p>
//             </div>
//           </RightCard>
//         </div>
//       </div>
//   {/* <BtnBack variant="outline" onClick={onBack}/>
// <BtnContinue variant="primary" disabled={!canContinue}
//             onClick={handleContinue} label="Continue"/> */}
//       <FooterBar
//         left={<BtnBack variant="outline" onClick={page === 0 ? onBack : () => setPage(p => p - 1)} />}
//         center={<p style={{ fontSize: 10, color: T.muted, margin: 0 }}>Page {page + 1} of {totalPages}</p>}
//         right={<BtnContinue variant="primary" label={page < totalPages - 1 ? "Next" : "Complete Questionnaire"} disabled={!pageAnswered} onClick={handleNext} />}
//       />
//         {showButton && (
//               <ScrollToBottomButton onClick={scrollToBottom} />
//             )}

//      </div>
//       {/* </PageWrap> */}
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // STEP PROGRESS NAV
// // ─────────────────────────────────────────────────────────────────────────────
// const SCREEN_ORDER = [
//   "start", "consent", "patient", "profile", "heightweight",
//   "lifestage", "entry", "condition", "safety", "adaptive", "done",
// ];
// const SCREEN_LABELS = {
//   start: "Journey", consent: "Consent", patient: "Patient",
//   profile: "Profile", heightweight: "Height/Wt", lifestage: "Life Stage",
//   entry: "Concerns", condition: "Symptoms", safety: "Safety",
//   adaptive: "Questions", done: "Done",
// };


// // ─────────────────────────────────────────────────────────────────────────────
// // ROOT APP
// // ─────────────────────────────────────────────────────────────────────────────
// export default function CareJourney() {
//   const [screen, setScreen] = useState("start");
//   const [allData, setAllData] = useState({
//     selectedJourney: null,
//     selectedRoute: null,
//     profile: {},
//     lifeStageAnswers: {},
//   });

//   const [patientState, setPatientState] = useState({
//     name: '',
//     mobile: '',
//     dob: '',
//     ageGroup: '',
//     occupation: '',
//     marital: '',
//     heightIn: '',
//     weightIn: '',
//     otp: ['', '', '', '', '', ''],
//     otpSent: false,
//     otpVerified: false,
//     nameError: '',
//     mobileError: '',
//   });

//   const mergePatientState = (d) => setPatientState(prev => ({ ...prev, ...d }));

//   const stepIndex = SCREEN_ORDER.indexOf(screen); // 0-based
//   const totalSteps = SCREEN_ORDER.length;

//   const merge = d => setAllData(prev => ({ ...prev, ...d }));
//   const go = key => setScreen(key);

//   const SCREENS = {
//     start: (
//       <StartCareJourneyScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         initialSelected={allData.selectedJourney}
//         onNext={selectedJourney => { merge({ selectedJourney }); go("consent"); }}
//         onBack={() => console.log("Back from start")}
//       />
//     ),
//     consent: (
//       <ConsentScreen
//         config={CONSENT_CONFIG}   // ← add this
//         // styles={styles}           // ← add this
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         onNext={() => go("patient")}
//         onBack={() => go("start")}
//       />
//     ),
//     patient: (
//       <NewPatientScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         patientState={patientState}
//         onPatientStateChange={mergePatientState}
//         onNext={() => go("profile")}
//         onBack={() => go("consent")}
//       />
//     ),
//     profile: (
//       <ProfileScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         patientState={patientState}
//         onPatientStateChange={mergePatientState}
//         initialValues={allData.profile}
//         onNext={d => { merge({ profile: { ...allData.profile, ...d } }); go("heightweight"); }}
//         onBack={() => go("patient")}
//       />
//     ),
//     heightweight: (
//       <HeightWeightScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         patientState={patientState}
//         onPatientStateChange={mergePatientState}
//         initialValues={{ heightIn: allData.heightIn, weightKg: allData.weightKg }}
//         onNext={d => { merge(d); go("lifestage"); }}
//         onBack={() => go("profile")}
//       />
//     ),
//     lifestage: (
//       <BasicLifeStageScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         profile={allData.profile}
//         initialValues={allData.lifeStageAnswers}
//         onNext={d => { merge({ lifeStageAnswers: d }); go("entry"); }}
//         onBack={() => go("heightweight")}
//       />
//     ),
//     entry: (
//       <EntryReasonScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         profile={allData.profile}
//         lifeStageAnswers={allData.lifeStageAnswers}
//         initialSelected={allData.selectedReasons || []}
//         onNext={d => { merge({ selectedReasons: d.selectedReasons, selectedRoute: d.selectedRoute }); go("condition"); }}
//         onBack={() => go("lifestage")}
//       />
//     ),
//     condition: (
//       <ConditionSpecificIntakeScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         selectedRoute={allData.selectedRoute}
//         selectedJourney={allData.selectedJourney}
//         profile={allData.profile}
//         lifeStageAnswers={allData.lifeStageAnswers}   // ← pass through
//         initialValues={{
//           selectedSymptoms: allData.selectedSymptoms || [],
//           duration: allData.duration || "",
//           severity: allData.severity || "",
//           tryingToConceive: allData.tryingToConceive || "",
//         }}
//         onNext={d => { merge(d); go("safety"); }}
//         onBack={() => go("entry")}
//       />
//     ),
//     safety: (
//       <SafetyCheckScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         initialSelected={allData.urgentSymptoms || []}
//         onNext={d => { merge(d); go("adaptive"); }}
//         onBack={() => go("condition")}
//       />
//     ),
//     adaptive: (
//       <AdaptiveQuestionnaireScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         allData={allData}
//         onNext={d => { merge({ adaptiveAnswers: d }); go("done"); }}
//         onBack={() => go("safety")}
//       />
//     ),
//     done: (
//       <CareRecommendationScreen
//         stepIndex={stepIndex}
//         totalSteps={totalSteps}
//         allData={{
//           ...allData,
//           lastPeriod: allData.lifeStageAnswers?.lmp || allData.lastPeriod || "",
//         }}
//         onBack={() => go("adaptive")}
//       />
//     ),
//     // done: (
//     //   <PageWrap>
//     //     <CareRecommendationScreen
//     //       allData={allData}
//     //       onBack={() => go("adaptive")}
//     //     />
//     //   </PageWrap>
//     // ),
//   };

//   return (
//     <>
//       <DigitalHealthFAB />
//       <div className={styles.page}>
//         <div className={styles.card}>
//           <div style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}>
//             {SCREENS[screen]}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
import { useEffect, useState } from "react";
import {
  getLifeStages,
  getVisibleQuestions,
  formatStageLabel,
  getEntryReasons,
  getLifeStageDetail,
  getLifeStageMeta,
} from "../components/Reusablesteps/Resolvelifestage";
import { useNavigate } from "react-router-dom";
import StartCareJourneyScreen from "../components/CareJourney/Startcarejourney";
import NewPatientScreen from "../components/CareJourney/Newpatientscreen";
import ProfileScreen from "../components/CareJourney/Profilescreen";
import DigitalHealthFAB from "../components/Digitalhealth";
import CareRecommendationScreen from "../components/CareJourney/CareRecommendationScreen";
import HeightWeightScreen from "../components/CareJourney/Heightweightscreen";
import BasicLifeStageScreen from "../components/CareJourney/Basiclifestagescreen";
import StepperProgress from "../components/Reusablesteps/Stepperprogress";
import styles from '../styles/pagestyles.module.css';
import { BtnAskNavigator, BtnBack, BtnContinue } from "../components/Reusablecomponents/Button/Reusableutton";
import useScrollToBottom from "../hooks/useScrollToBottom";
import { ScrollToBottomButton } from "../components/common/ScrollToBottomButton";
import ConsentScreen from "../components/Reusablecomponents/Consentscreen/Consentscreen";
import { ScreenHeaderDFO } from "../components/HealthAssessment/SharedUI";
// import careJourneyContent from '../components/CareJourney/CareJourney.json';
import { BASE_URL } from "../api/apiClient";

// ─────────────────────────────────────────────────────────────────────────────
// DESIGN TOKENS
// ─────────────────────────────────────────────────────────────────────────────
const T = {
  purple900: "#1A0A3C",
  purple800: "#2D1466",
  purple700: "#3B1A8C",
  purple600: "#4C24A8",
  purple500: "#5B2EBF",
  purpleBtn: "#3D1A8A",
  purpleLight: "#EDE9FB",
  purpleBorder: "#6B48D3",
  purpleTag: "#E8E3FA",
  dark: "#0F0A1E",
  heading: "#1A1033",
  body: "#374151",
  sub: "#6B7280",
  muted: "#9CA3AF",
  border: "#E5E7EB",
  borderFocus: "#6B48D3",
  pageBg: "#FFFFFF",
  lavenderBg: "#F4F1FD",
  cardBg: "#FFFFFF",
  inputBg: "#FFFFFF",
  trustBg: "#EDE9FB",
  infoBg: "#EFF6FF",
  infoBorder: "#BFDBFE",
  infoText: "#1E40AF",
  green: "#10B981",
  amber: "#F59E0B",
  red: "#EF4444",
  pink: "#EC4899",
  pinkLight: "#FFF0F5",
  pinkBorder: "#FBCFE8",
};

// ─── getStageKey ───────────────────────────────────────────────────────────
export function getStageKey(stage) {
  if (!stage) return "youngAdult";
  const s = stage.toString().toLowerCase().replace(/\s+/g, "");
  if (s.includes("adolesc")) return "adolescence";
  if (s.includes("young")) return "youngAdult";
  if (s.includes("mature")) return "matureReproductive";
  if (s.includes("peri")) return "perimenopause";
  if (s.includes("postmeno")) return "postmenopause";
  if (s.includes("meno")) return "menopause";
  if (s.includes("geriatric")) return "geriatric";
  return stage;
}


// ─── ENTRY_REASONS_STATIC ──────────────────────────────────────────────────
export const ENTRY_REASONS_STATIC = {
  menstrual_health: { label: "Menstrual Health", emoji: "🗓️", desc: "Cycle irregularities, cramps, heavy or missed periods." },
  pcos_screening: { label: "PCOS Screening", emoji: "🔬", desc: "Hormonal symptoms, acne, hair growth, weight changes." },
  pelvic_pain: { label: "Pelvic Pain", emoji: "💜", desc: "Lower abdominal, back, or pelvic floor pain." },
  menopause_symptoms: { label: "Menopause Symptoms", emoji: "🌡️", desc: "Hot flushes, night sweats, mood and sleep changes." },
  infection_gynae: { label: "Infection / Discharge", emoji: "🔬", desc: "Unusual discharge, itching, burning, or odour." },
  early_pregnancy: { label: "Early Pregnancy", emoji: "🤰", desc: "Missed period, nausea, breast tenderness, fatigue." },
  preconception: { label: "Preconception Care", emoji: "🌿", desc: "Cycle tracking, supplements, health checks before TTC." },
  fertility: { label: "Fertility", emoji: "🌿", desc: "Challenges conceiving, ovulation, or cycle concerns." },
  heavy_bleeding: { label: "Heavy Bleeding", emoji: "🩸", desc: "Soaking pads, clots, prolonged or irregular bleeding." },
  urogenital: { label: "Urogenital Health", emoji: "💧", desc: "Dryness, urgency, leakage, or pelvic floor concerns." },
  bone_health: { label: "Bone & Heart Health", emoji: "🦴", desc: "Joint pain, fracture risk, blood pressure, cholesterol." },
  mental_wellbeing: { label: "Mood & Mental Wellbeing", emoji: "🧠", desc: "Low mood, anxiety, sleep problems, or burnout." },
  contraception: { label: "Contraception", emoji: "💊", desc: "Choosing, changing, or managing contraception." },
  puberty_education: { label: "Puberty & Education", emoji: "📚", desc: "First period, cycle questions, body changes guidance." },
  lifestyle: { label: "Lifestyle & Wellness", emoji: "🥗", desc: "Weight, energy, sleep, stress, nutrition, fitness." },
  preventive_care: { label: "Preventive Care", emoji: "✅", desc: "Screenings, vaccinations, wellness checks." },
  chronic_disease: { label: "Chronic Condition Care", emoji: "🩺", desc: "Diabetes, thyroid, BP, ongoing medication management." },
};

// ─────────────────────────────────────────────────────────────────────────────
// HELPER — resolve life stage info from profile (used across all screens)
// ─────────────────────────────────────────────────────────────────────────────
/**
 * resolveLifeStageFromProfile(profile, lifeStageAnswers)
 * Single source of truth for stage resolution used by every screen.
 * Priority: lifeStageAnswers.stages → getLifeStages(profile.age, profile.marital)
 */


// ─────────────────────────────────────────────────────────────────────────────
// REUSABLE PRIMITIVE COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────
export const IconCircle = ({ children, size = 36, bg = T.purpleLight }) => (
  <div style={{
    width: size, height: size, borderRadius: "50%", background: bg,
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0, fontSize: size * 0.42,
  }}>
    {children}
  </div>
);

export const StageBadge = ({ label, emoji }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", gap: 6,
    background: T.purpleTag, borderRadius: 20, padding: "4px 12px",
    fontSize: 11, fontWeight: 600, color: T.purple700,
  }}>
    {emoji || "🌸"} {label}
  </span>
);

export const SectionLabel = ({ children }) => (
  <p style={{ fontSize: 10, fontWeight: 700, color: T.muted, letterSpacing: "0.08em", textTransform: "uppercase", padding: "10px 0 4px", margin: 0 }}>
    {children}
  </p>
);

export const Chip = ({ label, selected, onClick }) => (
  <button onClick={onClick} style={{
    padding: "7px 14px", borderRadius: 8, fontSize: 11, fontWeight: selected ? 600 : 400,
    border: selected ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
    background: selected ? T.purpleLight : "#fff",
    color: selected ? T.purple700 : T.sub,
    cursor: "pointer", transition: "all 0.15s",
  }}>
    {label}
  </button>
);

export const SymptomChip = ({ label, selected, onClick }) => {
  const icon = SYMPTOM_ICONS[label] || "•";
  return (
    <button onClick={onClick} style={{
      display: "flex", alignItems: "center", gap: 8, padding: "10px 14px",
      borderRadius: 12, textAlign: "left", position: "relative",
      border: selected ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
      // background: selected ? T.purpleLight : "#fff",
      color: selected ? T.purple700 : T.body,
      cursor: "pointer", fontSize: 12, fontWeight: selected ? 600 : 400,
      transition: "all 0.18s",
    }}>
      <IconCircle size={32} bg={selected ? "#D8D0F8" : "#F3F4F6"}>{icon}</IconCircle>
      <span style={{ flex: 1 }}>{label}</span>
      {selected && (
        <div style={{ width: 20, height: 20, borderRadius: "50%", background: T.purple700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
            <path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}
    </button>
  );
};

export const CareCheckbox = ({ checked, onChange }) => (
  <div onClick={onChange} style={{
    width: 20, height: 20, borderRadius: 5, flexShrink: 0, cursor: "pointer",
    border: checked ? "none" : `2px solid ${T.border}`,
    background: checked ? T.purple700 : "#fff",
    display: "flex", alignItems: "center", justifyContent: "center",
  }}>
    {checked && <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}
  </div>
);

export const Toggle = ({ on, onChange }) => (
  <div onClick={onChange} style={{
    width: 40, height: 22, borderRadius: 11, cursor: "pointer",
    background: on ? T.purple700 : T.border, position: "relative", transition: "background 0.2s",
  }}>
    <div style={{
      width: 16, height: 16, borderRadius: "50%", background: "#fff",
      position: "absolute", top: 3, left: on ? 21 : 3, transition: "left 0.2s",
    }} />
  </div>
);

export const InfoBox = ({ children }) => (
  <div style={{ background: T.infoBg, border: `1px solid ${T.infoBorder}`, borderRadius: 8, padding: "8px 10px" }}>
    <p style={{ fontSize: 10, color: T.infoText, margin: 0, lineHeight: 1.5 }}>ℹ️ {children}</p>
  </div>
);

export const PurpleInfoBox = ({ icon, title, desc }) => (
  <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", gap: 8 }}>
    <span style={{ fontSize: 14 }}>{icon}</span>
    <div>
      <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, margin: "0 0 2px" }}>{title}</p>
      <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{desc}</p>
    </div>
  </div>
);

export const TrustBar = () => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 12, padding: "8px 0 2px" }}>
    {["🔒 Secure", "👩‍⚕️ Expert-led", "🌸 Personalised"].map(item => (
      <span key={item} style={{ fontSize: 10, color: T.muted, fontWeight: 500 }}>{item}</span>
    ))}
  </div>
);

export const FeatureItem = ({ icon, title, desc }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
    <div style={{ width: 28, height: 28, borderRadius: 8, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>{icon}</div>
    <div>
      <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: "0 0 2px" }}>{title}</p>
      <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{desc}</p>
    </div>
  </div>
);

export const StyledSelect = ({ value, onChange, options, placeholder }) => (
  <div style={{ position: "relative" }}>
    <select value={value} onChange={e => onChange(e.target.value)} style={{
      width: "100%", padding: "10px 36px 10px 12px", borderRadius: 8, appearance: "none",
      border: `1.5px solid ${value ? T.purpleBorder : T.border}`,
      fontSize: 12, color: value ? T.heading : T.muted,
      background: "#fff", cursor: "pointer", outline: "none",
    }}>
      <option value="">{placeholder}</option>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
    <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: T.muted, fontSize: 12 }}>▾</span>
  </div>
);

export const YesNoBtn = ({ label, active, onClick }) => (
  <button onClick={onClick} style={{
    padding: "6px 16px", borderRadius: 8, fontSize: 11, fontWeight: active ? 700 : 400,
    border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
    background: active ? T.purpleLight : "#fff",
    color: active ? T.purple700 : T.sub, cursor: "pointer", transition: "all 0.15s",
  }}>
    {label}
  </button>
);

export const YesNo = ({ value, onChange }) => (
  <div style={{ display: "flex", gap: 8 }}>
    {["Yes", "No"].map(opt => (
      <button key={opt} onClick={() => onChange(opt)} style={{
        flex: 1, padding: "10px 0", borderRadius: 8, fontSize: 12,
        border: value === opt ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
        background: value === opt ? T.purpleLight : "#fff",
        color: value === opt ? T.purple700 : T.sub,
        fontWeight: value === opt ? 700 : 400, cursor: "pointer", transition: "all 0.15s",
      }}>
        {opt}
      </button>
    ))}
  </div>
);



export const FooterNote = ({ children }) => (
  <p style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, color: T.muted, margin: 0, whiteSpace: "nowrap" }}>
    🔒 {children}
  </p>
);

export const FooterBar = ({ left, center, right }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
  }}>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
  </div>
);

export const PageWrap = ({ children }) => (
  <div style={{
    minHeight: "100vh",
    background: "linear-gradient(135deg,#e8f4f8 0%,#f0eeff 50%,#e8f4f8 100%)",
    display: "flex", alignItems: "flex-start", justifyContent: "center",
    padding: "48px 16px 24px", fontFamily: "system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  }}>
    <div style={{
      width: "100%", maxWidth: 960, background: "white", borderRadius: 20,
      padding: "24px 32px 20px", boxShadow: "0 4px 40px rgba(61,26,138,0.09)",
      border: `1px solid ${T.border}`, boxSizing: "border-box",
    }}>
      {children}
    </div>
  </div>
);

export const RightCard = ({ children, style = {} }) => (
  <div style={{
    background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
    display: "flex", flexDirection: "column", gap: 10, ...style,
  }}>
    {children}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// SYMPTOM ICONS MAP
// ─────────────────────────────────────────────────────────────────────────────
const SYMPTOM_ICONS = {
  "Irregular periods": "🗓️", "Acne": "🫧", "Facial hair growth": "✨",
  "Weight gain": "⚖️", "Hair thinning": "💆", "Pelvic pain": "💜",
  "Bloating": "🫁", "Breast tenderness": "🌸", "Mood swings": "🧠",
  "Headaches/migraines": "🤕", "Nausea": "🤢", "Fatigue": "😴",
  "None of the above": "✅", "Lower abdomen": "📍", "Lower back": "🔙",
  "Pelvic floor / between the hip bones": "💜", "During sex (deep pain)": "❤️",
  "During urination": "💧", "During bowel movements": "⚠️",
  "Hot flushes": "🌡️", "Night sweats": "💧", "Sleep disturbances": "🌙",
  "Reduced sex drive": "❤️", "Vaginal dryness": "💧",
  "Joint pain or stiffness": "🦴",
  "Unusual discharge (colour, smell, or texture)": "🔬",
  "Itching or burning": "🔥", "Pain during sex": "❤️",
  "Pain or burning when urinating": "💧", "Fever or chills": "🌡️",
  "Pelvic pain or pressure": "💜",
};
// const getSymptomIcon = (label) => SYMPTOM_ICONS[label] || "•";

// ─────────────────────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────────────────────

export function getSafetySymptoms(routeKey,careJourneyContent) {
  const config = careJourneyContent.screens?.safetyCheck || {};
  return config[routeKey] || config.default || [];
}
const OptionCard = ({ emoji, label, desc, selected, onClick, badge }) => (
  <button onClick={onClick} style={{
    position: "relative", textAlign: "left", borderRadius: 12, padding: "12px 12px 10px",
    // background: selected ? T.purpleLight : T.cardBg,
    border: selected ? `2px solid ${T.purpleBorder}` : `1px solid ${T.border}`,
    cursor: "pointer", display: "flex", flexDirection: "column", transition: "all 0.2s",
  }}>
    {selected && (
      <div style={{ position: "absolute", top: 8, right: 8, width: 20, height: 20, background: T.purple700, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </div>
    )}
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
      <IconCircle size={36}>{emoji}</IconCircle>
      <p style={{ fontWeight: 700, fontSize: 11, lineHeight: 1.3, color: T.heading, paddingRight: selected ? 20 : 0, margin: 0 }}>{label}</p>
    </div>
    <p style={{ fontSize: 10, lineHeight: 1.4, color: T.sub, flex: 1, margin: "0 0 6px" }}>{desc}</p>
    {badge && <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 99, color: badge.color, background: badge.bg, alignSelf: "flex-start", marginBottom: 4 }}>{badge.label}</span>}
    {/* <span style={{ fontSize: 11, fontWeight: 600, color: T.purple700 }}>Explore →</span> */}
  </button>
);

// ─────────────────────────────────────────────────────────────────────────────
// ADAPTIVE QUESTIONS BUILDER
// ─────────────────────────────────────────────────────────────────────────────

function matchesClause(clause, ctx) {
  if (clause.always) return true;
  if (clause.stage) return ctx.hasStage(clause.stage);
  if (clause.route) return ctx.route === clause.route;
  if (clause.symptom) return ctx.hasSym(clause.symptom);
  if (clause.journey) return ctx.selectedJourney === clause.journey;
  if (clause.tryingToConceive) return ctx.tryingToConceive === clause.tryingToConceive;
  if (clause.severity) return ctx.severity === clause.severity;
  if (clause.duration) return ctx.duration === clause.duration;
  if (clause.urgentPresent) return ctx.urgentSymptoms.length > 0 && !ctx.urgentSymptoms.includes("None of these");
  return false;
}

function buildAdaptiveQuestions(allData,careJourneyContent) {
  const {
    selectedJourney,
    selectedRoute,
    selectedSymptoms = [],
    duration,
    severity,
    tryingToConceive,
    urgentSymptoms = [],
    lifeStageAnswers = {},
    profile = {},
  } = allData;

  const stages = lifeStageAnswers?.stages?.length > 0
    ? lifeStageAnswers.stages
    : getLifeStages(profile?.age, profile?.marital);

  const ctx = {
    hasStage: key => stages.includes(key),
    hasSym: s => selectedSymptoms.includes(s),
    route: selectedRoute || "",
    selectedJourney,
    tryingToConceive,
    severity,
    duration,
    urgentSymptoms,
  };

  const pool = careJourneyContent.screens?.adaptiveQuestions?.questions || [];
  const limit = careJourneyContent.screens?.adaptiveQuestions?.poolLimit || 8;

  const qs = pool.filter(q => (q.when || []).some(clause => matchesClause(clause, ctx)));

  const seen = new Set();
  return qs
    .filter(q => {
      if (seen.has(q.id)) return false;
      seen.add(q.id);
      return true;
    })
    .slice(0, limit);
}

// ─────────────────────────────────────────────────────────────────────────────
// SCREEN 7 — Entry Reason
// ─────────────────────────────────────────────────────────────────────────────

// ─── Resolve entry reasons purely from careJourneyContent ──────────────────
function resolveEntryReasonsFromJSON(stages,careJourneyContent) {
  const config = careJourneyContent.screens?.entryReasons || {};
  for (const s of stages) {
    if (config[s]) {
      const cfg = config[s];
      return {
        journeyTitle: cfg.journeyTitle,
        screenTitle: cfg.screenTitle,
        options: (cfg.options || [])
          .filter((o) => o.status !== 0)
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
      };
    }
  }
  return null;
}

function resolveLifeStageFromProfile(profile = {}, lifeStageAnswers = {},careJourneyContent) {
  const stages =
    lifeStageAnswers?.stages?.length > 0
      ? lifeStageAnswers.stages
      : getLifeStages(profile?.age, profile?.marital);

  const primaryStage = stages[0] || "youngAdult";
  const stageDetail = getLifeStageDetail(primaryStage) || {};
  const stageMeta = getLifeStageMeta(primaryStage) || { emoji: "🌸", color: "#F4F1FD" };
  const stageName = stageDetail.name || formatStageLabel(primaryStage);
  const journey = resolveEntryReasonsFromJSON(stages,careJourneyContent);
  const journeyTitle = journey?.journeyTitle || "Women's Health Journey";
  const journeyEmoji = stageMeta.emoji || "🌸";

  return { stages, primaryStage, stageDetail, stageMeta, stageName, journey, journeyTitle, journeyEmoji };
}

export function EntryReasonScreen({
  profile,
  onNext,
  onBack,
  initialSelected = [],
  stepIndex,
  totalSteps,
  lifeStageAnswers = {},
   careJourneyContent
}) {
  const [selected, setSelected] = useState(initialSelected);

  const { stageMeta, stageName, journey } = resolveLifeStageFromProfile(profile, lifeStageAnswers,careJourneyContent);
  const toggle = (val) => setSelected((p) => (p.includes(val) ? p.filter((v) => v !== val) : [...p, val]));

  const getUrgencyBadge = (routeKey) => {
    if (!routeKey) return null;
    if (routeKey.toLowerCase().includes("urgent") || routeKey.toLowerCase().includes("triage"))
      return { label: "Urgent", color: T.red, bg: "#FEF2F2" };
    return null;
  };

  // selectedRoute now resolves to the machine-readable routeKey, which
  // ConditionSpecificIntakeScreen looks up directly in conditionIntake.
  const selectedOption = journey?.options?.find((o) => selected.includes(o.value));
  const selectedRoute = selectedOption?.routeKey || null;

  if (!journey) {
    // No JSON config for this stage yet — fail visibly instead of silently
    // rendering an empty grid, so gaps in care-journey.json surface immediately.
    return (
      <div style={{ padding: 24, color: T.red, fontSize: 13 }}>
        No entry-reason content configured for this life stage yet.
      </div>
    );
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ maxWidth: 480 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>
            {journey.screenTitle || "What brings you in today?"}
          </h1>
          <p style={{ fontSize: 11, color: T.sub, marginBottom: 8 }}>
            Based on your life stage, choose the option that best matches your concern.
          </p>
          <StageBadge label={journey.journeyTitle || stageName} emoji={stageMeta.emoji} />
        </div>
        <StepperProgress current={stepIndex} total={totalSteps} />
      </div>

      <div style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", border: `1px solid ${T.border}` }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
          {journey.options.map((opt) => (
            <OptionCard
              key={opt.id || opt.value}
              emoji={opt.emoji}
              label={opt.label}
              desc={opt.desc}
              selected={selected.includes(opt.value)}
              onClick={() => toggle(opt.value)}
              badge={getUrgencyBadge(opt.routeKey)}
            />
          ))}
        </div>
      </div>

      <FooterBar
        left={<BtnBack variant="outline" onClick={onBack} />}
        center={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <BtnAskNavigator onClick={() => { }} />
            <FooterNote>You can change your response later.</FooterNote>
          </div>
        }
        right={
          <BtnContinue
            variant="primary"
            label="Continue"
            disabled={selected.length === 0}
            onClick={() => onNext({ selectedReasons: selected, selectedRoute })}
          />
        }
      />
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SCREEN 8 — Condition Specific Intake
// ─────────────────────────────────────────────────────────────────────────────

export function ConditionSpecificIntakeScreen({
  onNext,
  onBack,
  stepIndex,
  totalSteps,
  selectedRoute,
  selectedJourney,
  profile,
  lifeStageAnswers = {},
  initialValues = {},
   careJourneyContent
}) {
  const [selectedSymptoms, setSelectedSymptoms] = useState(initialValues.selectedSymptoms || []);
  const [duration, setDuration] = useState(initialValues.duration || "");
  const [severity, setSeverity] = useState(initialValues.severity || "");
  const [tryingToConceive, setTryingToConceive] = useState(initialValues.tryingToConceive || "");

  const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();

  const { stageMeta, stageName, journeyTitle, journeyEmoji } = resolveLifeStageFromProfile(profile, lifeStageAnswers,careJourneyContent);

  const conditionConfig = careJourneyContent.screens?.conditionIntake || {};
  const sharedConfig = careJourneyContent.screens?.conditionIntakeShared || {};

  const routeKey = selectedRoute || "pcos_screening";
  const meta = conditionConfig[routeKey] || {
    title: "Tell us a bit more about your symptoms",
    desc: "We'll use your answers to personalise your next steps.",
    symptoms: [],
    showTryingConceive: false,
  };

  const symptoms = meta.symptoms?.length ? meta.symptoms : ["No symptoms configured for this route"];
  const DURATION_OPTS = sharedConfig.durationOptions || ["Less than 1 month", "1–3 months", "3–6 months", "6 months to 1 year", "More than 1 year"];
  const SEVERITY_OPTS = sharedConfig.severityOptions || ["Mild", "Moderate", "Severe", "Very severe"];
  const showTryingConceive = !!meta.showTryingConceive;

  const toggleSymptom = (s) =>
    setSelectedSymptoms((prev) => (prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s]));

  return (
    <>
      <div ref={scrollRef} style={{ height: "84vh", overflow: "scroll" }}>
        <div
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: stageMeta.color || T.purpleTag, borderRadius: 20, padding: "4px 12px",
            marginBottom: 14, fontSize: 11, fontWeight: 600, color: T.purple700,
          }}
        >
          {stageMeta.emoji} {stageName}
        </div>

        <div style={{ marginBottom: 18, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ maxWidth: 560 }}>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: T.heading, marginBottom: 6, lineHeight: 1.2 }}>
              {meta.title}
            </h1>
            <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>{meta.desc}</p>
          </div>
          <StepperProgress current={stepIndex} total={totalSteps} />
        </div>

        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: `1px solid ${T.border}`, marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                <div>
                  <p style={{ fontWeight: 700, fontSize: 13, color: T.heading, margin: 0, marginBottom: 2 }}>
                    What symptoms are you experiencing?
                  </p>
                  <p style={{ fontSize: 11, color: T.muted, margin: 0 }}>Select all that apply.</p>
                </div>
                <button
                  style={{
                    display: "flex", alignItems: "center", gap: 5, padding: "5px 12px", borderRadius: 20,
                    border: `1.5px solid ${T.border}`, background: "#fff", fontSize: 11, color: T.sub,
                    cursor: "pointer", fontWeight: 500, flexShrink: 0,
                  }}
                >
                  ℹ️ Why we ask
                </button>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginTop: 14 }}>
                {symptoms.map((s) => (
                  <SymptomChip key={s} label={s} selected={selectedSymptoms.includes(s)} onClick={() => toggleSymptom(s)} />
                ))}
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: showTryingConceive ? "1fr 1fr" : "1fr", gap: 12 }}>
              <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${T.border}` }}>
                <p style={{ fontSize: 12, fontWeight: 600, color: T.heading, marginBottom: 8 }}>
                  How long has this been happening?
                </p>
                <StyledSelect value={duration} onChange={setDuration} options={DURATION_OPTS} placeholder="Select duration" />
              </div>
              <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${T.border}` }}>
                <p style={{ fontSize: 12, fontWeight: 600, color: T.heading, marginBottom: 8 }}>
                  How severe are your symptoms? <span style={{ fontSize: 10, color: T.muted, fontWeight: 400 }}>ℹ️</span>
                </p>
                <StyledSelect value={severity} onChange={setSeverity} options={SEVERITY_OPTS} placeholder="Select severity" />
              </div>
            </div>
          </div>

          <div style={{ width: 230, flexShrink: 0 }}>
            <RightCard>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, margin: 0 }}>Your journey</p>
              </div>

              <div
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  background: stageMeta.color || T.lavenderBg, borderRadius: 10, padding: "10px 12px",
                }}
              >
                <div
                  style={{
                    width: 44, height: 44, borderRadius: 10, background: T.purpleLight,
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0,
                  }}
                >
                  {journeyEmoji}
                </div>
                <p style={{ fontWeight: 700, fontSize: 11, color: T.heading, margin: 0, lineHeight: 1.3 }}>{journeyTitle}</p>
              </div>

              <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
                We'll personalise your care plan based on your responses.
              </p>

              <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
                <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 2 }}>Est. time to complete</p>
                <p style={{ fontSize: 11, color: T.sub, margin: 0 }}>~5 min</p>
              </div>

              {selectedSymptoms.length > 0 && (
                <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
                  <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 6 }}>Your responses</p>
                  <p style={{ fontSize: 11, color: T.sub, margin: "0 0 8px" }}>
                    {selectedSymptoms.length} symptom{selectedSymptoms.length > 1 ? "s" : ""} selected
                  </p>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6, fontSize: "12px" }}>
                    <div className="flex flex-wrap gap-2">
                      {selectedSymptoms.map((item, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-3 py-1.5 rounded-full"
                          style={{ backgroundColor: "var(--blue)", color: "var(--primary-color)" }}
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                    {selectedSymptoms.length > 5 && (
                      <div
                        style={{
                          width: 30, height: 30, borderRadius: 8, background: T.purpleTag,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 10, fontWeight: 700, color: T.purple700,
                        }}
                      >
                        +{selectedSymptoms.length - 5}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </RightCard>
          </div>
        </div>

        <FooterBar
          left={<BtnBack onClick={onBack} variant="outline" />}
          center={<FooterNote>Your responses help personalise your care journey</FooterNote>}
          right={
            <BtnContinue
              variant="primary"
              label="Continue"
              disabled={selectedSymptoms.length === 0}
              onClick={() => onNext({ selectedSymptoms, duration, severity, tryingToConceive })}
            />
          }
        />
        {showButton && <ScrollToBottomButton onClick={scrollToBottom} />}
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SCREEN 9 — Safety Check
// ─────────────────────────────────────────────────────────────────────────────
export function SafetyCheckScreen({ onNext, onBack, initialSelected = [], stepIndex, totalSteps, 
   careJourneyContent,selectedRoute }) {
  const [selected, setSelected] = useState(initialSelected);
  const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();
  const toggle = label => {
    if (label === "None of these") { setSelected(["None of these"]); return; }
    setSelected(prev => {
      const without = prev.filter(x => x !== "None of these");
      return without.includes(label) ? without.filter(x => x !== label) : [...without, label];
    });
  };
  // console.log(selectedRoute,"this is the selected route")
  const SAFETY_SYMPTOMS = getSafetySymptoms(selectedRoute,careJourneyContent);
  const hasUrgent = selected.length > 0 && !selected.includes("None of these");
  const URGENCY = hasUrgent
    ? { concern: "Possible urgent symptoms reported", action: "Priority review needed", response: "We may guide you to same-day care", concernColor: T.red, actionColor: T.amber, responseColor: T.purple700 }
    : { concern: "No urgent symptoms reported", action: "Standard care pathway", response: "We'll guide you through personalized care", concernColor: T.green, actionColor: T.green, responseColor: T.purple700 };

  return (
    <>
      <div ref={scrollRef} style={{ height: "84vh", overflow: "scroll" }}>
        {/* <PageWrap> */}
        <div className="scj-header">

          <div>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 6 }}>Before we continue, let's make sure you're safe</h1>
            <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>Please tell us if you are experiencing any urgent symptoms right now.</p>
          </div>
          <StepperProgress current={stepIndex} total={totalSteps} />
        </div>

        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <div style={{ background: "#fff", borderRadius: 14, padding: 16, border: `1px solid ${T.border}`, marginBottom: 14 }}>
              <p style={{ fontWeight: 700, fontSize: 13, color: T.heading, marginBottom: 4 }}>Are you currently experiencing any of these?</p>
              <p style={{ fontSize: 11, color: T.muted, marginBottom: 14 }}>Select all that apply.</p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                {SAFETY_SYMPTOMS.map(({ label, icon }) => {
                  const isSel = selected.includes(label);
                  const isNone = label === "None of these";
                  const isUrg = isSel && !isNone;
                  return (
                    <button key={label} onClick={() => toggle(label)} style={{
                      display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, cursor: "pointer", textAlign: "left", transition: "all 0.15s",
                      border: isSel ? `2px solid ${isUrg ? "#FCA5A5" : isNone ? T.green : T.purpleBorder}` : `1.5px solid ${T.border}`,
                      background: isSel ? isUrg ? "#FEF2F2" : isNone ? "#ECFDF5" : T.purpleLight : "#fff",
                    }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: isSel ? isUrg ? "#FEE2E2" : isNone ? "#D1FAE5" : T.purpleLight : "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{icon}</div>
                      <span style={{ fontSize: 12, fontWeight: isSel ? 600 : 400, color: isSel ? isUrg ? "#991B1B" : isNone ? "#065F46" : T.purple700 : T.body, flex: 1 }}>{label}</span>
                      <div style={{ width: 18, height: 18, borderRadius: 4, border: isSel ? "none" : `1.5px solid ${T.border}`, background: isSel ? isUrg ? T.red : isNone ? T.green : T.purple700 : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        {isSel && <svg width="10" height="8" viewBox="0 0 12 9" fill="none"><path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}
                      </div>
                    </button>
                  );
                })}
              </div>
              <div style={{ marginTop: 12, display: "flex", alignItems: "flex-start", gap: 8, background: T.infoBg, borderRadius: 8, padding: "8px 10px", border: `1px solid ${T.infoBorder}` }}>
                <span style={{ fontSize: 14, flexShrink: 0 }}>ℹ️</span>
                <p style={{ fontSize: 10, color: T.infoText, margin: 0, lineHeight: 1.5 }}>If you are pregnant, postpartum, or have severe symptoms, our care team may recommend urgent evaluation.</p>
              </div>
            </div>

            <div style={{ background: "#fff", borderRadius: 12, padding: 14, border: `1px solid ${hasUrgent ? "#FCA5A5" : T.border}` }}>
              <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, marginBottom: 10 }}>Urgency Check</p>
              {[
                { icon: "⚠️", label: "Current concern", value: URGENCY.concern, color: URGENCY.concernColor },
                { icon: "🔶", label: "Suggested action", value: URGENCY.action, color: URGENCY.actionColor },
                { icon: "💜", label: "Care team response", value: URGENCY.response, color: URGENCY.responseColor },
              ].map(row => (
                <div key={row.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${T.border}` }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ fontSize: 14 }}>{row.icon}</span>
                    <span style={{ fontSize: 11, color: T.body, fontWeight: 500 }}>{row.label}</span>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 600, color: row.color, textAlign: "right", maxWidth: 200 }}>{row.value}</span>
                </div>
              ))}
              {hasUrgent && (
                <div style={{ marginTop: 10, display: "flex", alignItems: "flex-start", gap: 8, background: "#FFFBEB", borderRadius: 8, padding: "8px 10px", border: `1px solid #FDE68A` }}>
                  <span style={{ fontSize: 14 }}>⚠️</span>
                  <p style={{ fontSize: 10, color: "#92400E", margin: 0, lineHeight: 1.5 }}>This screen does not provide a diagnosis. If symptoms are severe, seek urgent medical care.</p>
                </div>
              )}
            </div>
          </div>

          <div style={{ width: 230, flexShrink: 0 }}>
            <RightCard>
              <div style={{ textAlign: "center", fontSize: 48 }}>🛡️</div>
              <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, textAlign: "center" }}>Your safety comes first</p>
              <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0, textAlign: "center" }}>This quick check helps us identify if you need immediate attention before proceeding.</p>
              <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
                {[
                  { icon: "🚨", title: "Urgent symptoms", desc: "We may direct you to same-day or emergency care." },
                  { icon: "🩺", title: "Non-urgent", desc: "We'll continue personalizing your care journey." },
                  { icon: "🔒", title: "Secure & Private", desc: "Reviewed only by authorized care team members." },
                ].map(f => (
                  <div key={f.title} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 10 }}>
                    <div style={{ width: 30, height: 30, borderRadius: 8, background: T.purpleLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>{f.icon}</div>
                    <div>
                      <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: "0 0 2px" }}>{f.title}</p>
                      <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ textAlign: "center", fontSize: 10, color: T.muted, paddingTop: 4, borderTop: `1px solid ${T.border}` }}>🔒 Secure · Private · Reviewed by care team</div>
            </RightCard>
          </div>
        </div>

        <FooterBar
          left={<BtnBack variant="outline" onClick={onBack} />}
          center={null}
          right={<BtnContinue variant="primary" label={hasUrgent ? "⚠️ Continue — I Understand" : "Continue"} color={hasUrgent ? T.red : T.purpleBtn} disabled={selected.length === 0} onClick={() => onNext({ urgentSymptoms: selected, hasUrgent })} />}
        />
        {/* </PageWrap> */}
        {showButton && (
          <ScrollToBottomButton onClick={scrollToBottom} />
        )}
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SCREEN 10 — Adaptive Questionnaire
// ─────────────────────────────────────────────────────────────────────────────
export function AdaptiveQuestionnaireScreen({ onNext, onBack, allData = {}, totalSteps, stepIndex, careJourneyContent}) {
  const { scrollRef, showButton, scrollToBottom } = useScrollToBottom();
  const questions = buildAdaptiveQuestions(allData,careJourneyContent);
  // const [answers, setAnswers] = useState({});
  const [answers, setAnswers] = useState(allData?.adaptiveAnswers || {});
  const [page, setPage] = useState(0);

  // ── Dynamically resolve life stage ──
  const { stages, stageMeta, stageName, stageDetail } =
    resolveLifeStageFromProfile(allData?.profile || {}, allData?.lifeStageAnswers || {},careJourneyContent);

  const PER_PAGE = 4;
  const totalPages = Math.ceil(questions.length / PER_PAGE);
  const pageQs = questions.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

  const setAns = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));
  const toggleAns = (id, val) => setAnswers(prev => {
    const cur = prev[id] || [];
    return { ...prev, [id]: cur.includes(val) ? cur.filter(x => x !== val) : [...cur, val] };
  });

  const pageAnswered = pageQs.every(q => {
    const a = answers[q.id];
    return q.type === "multi" ? a && a.length > 0 : !!a;
  });

  const answered = questions.filter(q => !!answers[q.id] && (q.type !== "multi" || answers[q.id]?.length > 0)).length;
  const progressPct = Math.round((answered / questions.length) * 100);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(p => p + 1);
    else onNext(answers);
  };

  return (
    <>
      {/* <PageWrap> */}
      {/* Dynamic stage tag */}
      <div ref={scrollRef} style={{ height: "84vh", overflow: "scroll" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: stageMeta.color || T.purpleTag, borderRadius: 20, padding: "4px 12px", marginBottom: 14, fontSize: 11, fontWeight: 600, color: T.purple700 }}>
          {stageMeta.emoji} Adaptive Questionnaire · {stageName}
        </div>

        <div style={{ marginBottom: 18, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ maxWidth: 560 }}>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: T.heading, marginBottom: 6 }}>A few more personalised questions</h1>
            <p style={{ fontSize: 12, color: T.sub, margin: 0 }}>Based on your responses, we've tailored these questions to build the most accurate care plan for you.</p>
          </div>
          <StepperProgress current={stepIndex} total={totalSteps} />
          {/* <div style={{ fontSize: 56, userSelect: "none", marginTop: -8 }}>🎯</div> */}
        </div>

        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 14 }}>
            {pageQs.map((question, idx) => {
              const val = answers[question.id];
              const globalIdx = page * PER_PAGE + idx;
              return (
                <div key={question.id} style={{ background: "#fff", borderRadius: 14, padding: 18, border: `1px solid ${val ? T.purpleBorder : T.border}`, transition: "border-color 0.2s" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%", background: val ? T.purple700 : T.purpleLight, color: val ? "#fff" : T.purple700, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0, transition: "all 0.2s" }}>
                      {val ? "✓" : globalIdx + 1}
                    </div>
                    <p style={{ fontSize: 13, fontWeight: 600, color: T.heading, margin: 0, lineHeight: 1.3 }}>{question.q}</p>
                    {question.type === "multi" && <span style={{ fontSize: 10, color: T.muted, background: "#F3F4F6", borderRadius: 4, padding: "2px 6px", flexShrink: 0 }}>Multi-select</span>}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {question.options.map(opt => {
                      const active = question.type === "multi" ? (val || []).includes(opt) : val === opt;
                      return (
                        <button key={opt} onClick={() => question.type === "multi" ? toggleAns(question.id, opt) : setAns(question.id, opt)} style={{
                          padding: "8px 16px", borderRadius: 8, fontSize: 12, cursor: "pointer", transition: "all 0.15s",
                          border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
                          background: active ? T.purpleLight : "#fff",
                          color: active ? T.purple700 : T.sub,
                          fontWeight: active ? 600 : 400,
                        }}>
                          {opt}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Sidebar */}
          <div style={{ width: 220, flexShrink: 0 }}>
            <RightCard>
              <p style={{ fontWeight: 700, fontSize: 12, color: T.heading, marginBottom: 2 }}>Your progress</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "8px 0" }}>
                <div style={{ width: 80, height: 80, borderRadius: "50%", background: T.purpleLight, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: `4px solid ${T.purple700}` }}>
                  <span style={{ fontSize: 20, fontWeight: 800, color: T.purple700 }}>{progressPct}%</span>
                  <span style={{ fontSize: 9, color: T.muted }}>complete</span>
                </div>
              </div>
              {/* Questions tracker */}
              <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
                <p style={{ fontWeight: 600, fontSize: 10, color: T.heading, marginBottom: 6 }}>Questions answered</p>
                {questions.map((q, i) => {
                  const ans = !!answers[q.id] && (q.type !== "multi" || answers[q.id]?.length > 0);
                  return (
                    <div key={q.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <div style={{ width: 18, height: 18, borderRadius: "50%", background: ans ? T.green : T.border, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, flexShrink: 0, transition: "background 0.3s" }}>
                        {ans && <svg width="8" height="7" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>}
                      </div>
                      <p style={{ fontSize: 10, color: ans ? T.heading : T.muted, margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: ans ? 600 : 400 }}>
                        Q{i + 1}: {q.q.slice(0, 28)}…
                      </p>
                    </div>
                  );
                })}
              </div>

              <div style={{ background: T.lavenderBg, borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "flex-start", gap: 6 }}>
                <span style={{ fontSize: 14 }}>🎯</span>
                <p style={{ fontSize: 10, color: T.sub, margin: 0, lineHeight: 1.4 }}>These questions were selected based on your life stage, symptoms and journey type.</p>
              </div>
            </RightCard>
          </div>
        </div>

        <FooterBar
          left={<BtnBack variant="outline" onClick={page === 0 ? onBack : () => setPage(p => p - 1)} />}
          center={<p style={{ fontSize: 10, color: T.muted, margin: 0 }}>Page {page + 1} of {totalPages}</p>}
          right={<BtnContinue variant="primary" label={page < totalPages - 1 ? "Next" : "Complete Questionnaire"} disabled={!pageAnswered} onClick={handleNext} />}
        />
        {showButton && (
          <ScrollToBottomButton onClick={scrollToBottom} />
        )}

      </div>
      {/* </PageWrap> */}
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// STEP PROGRESS NAV
// ─────────────────────────────────────────────────────────────────────────────
const SCREEN_ORDER = [
  "start", "consent", "patient", "profile", "heightweight",
  "lifestage", "entry", "condition", "safety", "adaptive", "done",
];
const SCREEN_LABELS = {
  start: "Journey", consent: "Consent", patient: "Patient",
  profile: "Profile", heightweight: "Height/Wt", lifestage: "Life Stage",
  entry: "Concerns", condition: "Symptoms", safety: "Safety",
  adaptive: "Questions", done: "Done",
};


// ─────────────────────────────────────────────────────────────────────────────
// ROOT APP
// ─────────────────────────────────────────────────────────────────────────────
export default function CareJourney() {
  const [screen, setScreen] = useState("start");
  const [allData, setAllData] = useState({
    selectedJourney: null,
    selectedRoute: null,
    profile: {},
    lifeStageAnswers: {},
  });
  const [careJourneyContent, setCareJourneyContent] = useState({});
  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/care-journey/?clinic=mukta`)
        const data = await res.json();
        setCareJourneyContent(data);
      } catch (error) {
        console.log(error, "error while fetching the json of care journey");
      }
    }
    fetchContent();
  }, [])

  const [patientState, setPatientState] = useState({
    name: '',
    mobile: '',
    dob: '',
    ageGroup: '',
    occupation: '',
    marital: '',
    heightIn: '',
    weightIn: '',
    otp: ['', '', '', '', '', ''],
    otpSent: false,
    otpVerified: false,
    nameError: '',
    mobileError: '',
  });
console.log(allData,"allDataallDataallData")
  const mergePatientState = (d) => setPatientState(prev => ({ ...prev, ...d }));

  const stepIndex = SCREEN_ORDER.indexOf(screen); // 0-based
  const totalSteps = SCREEN_ORDER.length;

  const merge = d => setAllData(prev => ({ ...prev, ...d }));
  const go = key => setScreen(key);

  const SCREENS = {
    start: (
      <StartCareJourneyScreen
      careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        initialSelected={allData.selectedJourney}
        onNext={selectedJourney => { merge({ selectedJourney }); go("consent"); }}
        onBack={() => console.log("Back from start")}
      />
    ),
    consent: (
      <ConsentScreen

        config={careJourneyContent.screens?.consent}

        stepIndex={stepIndex}
        totalSteps={totalSteps}
        onNext={() => go("patient")}
        onBack={() => go("start")}
      />
    ),
    patient: (
      <NewPatientScreen
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        patientState={patientState}
        onPatientStateChange={mergePatientState}
        onNext={() => go("profile")}
        onBack={() => go("consent")}
      />
    ),
    profile: (
      <ProfileScreen 
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        patientState={patientState}
        onPatientStateChange={mergePatientState}
        initialValues={allData.profile}

        onNext={d => {
          merge({ profile: { ...allData.profile, ...d } });

          // ← persist to localStorage
          try {
            const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
            localStorage.setItem("patientPersona", JSON.stringify({
              ...existing,
              ...d,               // ageGroup, marital, occupation
              savedAt: Date.now(),
            }));
          } catch (e) {
            console.error("Failed to persist profile to localStorage", e);
          }

          go("heightweight");
        }}
        onBack={() => go("patient")}
      />
    ),
    heightweight: (
      <HeightWeightScreen
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        patientState={patientState}
        onPatientStateChange={mergePatientState}
        initialValues={{ heightIn: allData.heightIn, weightIn: allData.weightIn }}
        onNext={d => { merge(d); go("lifestage"); }}
        onBack={() => go("profile")}
      />
    ),
    lifestage: (
      <BasicLifeStageScreen
      careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        profile={allData.profile}
        initialValues={allData.lifeStageAnswers}
        onNext={d => { merge({ lifeStageAnswers: d }); go("entry"); }}
        onBack={() => go("heightweight")}
      />
    ),
    entry: (
      <EntryReasonScreen
       careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        profile={allData.profile}
        lifeStageAnswers={allData.lifeStageAnswers}
        initialSelected={allData.selectedReasons || []}
        onNext={d => { merge({ selectedReasons: d.selectedReasons, selectedRoute: d.selectedRoute }); go("condition"); }}
        onBack={() => go("lifestage")}
      />
    ),
    condition: (
      <ConditionSpecificIntakeScreen
       careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        selectedRoute={allData.selectedRoute}
        selectedJourney={allData.selectedJourney}
        profile={allData.profile}
        lifeStageAnswers={allData.lifeStageAnswers}   // ← pass through
        initialValues={{
          selectedSymptoms: allData.selectedSymptoms || [],
          duration: allData.duration || "",
          severity: allData.severity || "",
          tryingToConceive: allData.tryingToConceive || "",
        }}
        onNext={d => { merge(d); go("safety"); }}
        onBack={() => go("entry")}
      />
    ),
    safety: (
      <SafetyCheckScreen
       careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        selectedRoute={allData.selectedRoute}
        initialSelected={allData.urgentSymptoms || []}
        onNext={d => { merge(d); go("adaptive"); }}
        onBack={() => go("condition")}
      />
    ),
    adaptive: (
      <AdaptiveQuestionnaireScreen
        stepIndex={stepIndex}
         careJourneyContent={careJourneyContent}
        totalSteps={totalSteps}
        allData={allData}
        onNext={d => { merge({ adaptiveAnswers: d }); go("done"); }}
        onBack={() => go("safety")}
      />
    ),
    done: (
      <CareRecommendationScreen
       careJourneyContent={careJourneyContent}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        allData={{
          ...allData,
          lastPeriod: allData.lifeStageAnswers?.lmp || allData.lastPeriod || "",
        }}
        onBack={() => go("adaptive")}
      />
    ),
  };

  return (
    <>
      <DigitalHealthFAB />
      <div className={styles.page}>
        <div className={styles.card}>
          <ScreenHeaderDFO />
          <div style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}>
            {SCREENS[screen]}
          </div>
        </div>
      </div>
    </>
  );
}